import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: any; output: any };
  AWSDateTime: { input: any; output: any };
  AWSJSON: { input: any; output: any };
  AWSURL: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type IAcademicCalendar = {
  /** Academic Partner UUID */
  academicPartnerId: Scalars['ID']['output'];
  /** Academic Periods attached to this calendar */
  academicPeriods: Array<IAcademicPeriod>;
  /** All exchange date formulas */
  expectedExchangeDateFormulas?: Maybe<IExpectedExchangeDateFormulas>;
  /** All other calendar date formulas that are not exchange date formulas */
  formulas?: Maybe<IAcademicCalendarFormulas>;
  /** Have all the Calendar's Academic Period's been approved? */
  hasApproval: Scalars['Boolean']['output'];
  /** Unique identifier UUID */
  id: Scalars['ID']['output'];
  /** Calendar name */
  name: Scalars['String']['output'];
  /** Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Published */
  published: Scalars['Boolean']['output'];
  /** Calendar status (partial, draft, approved, etc..) */
  status: IAcademicCalendarStatus;
  updatedAt: Scalars['String']['output'];
};

/**
 * Filter a Calendar with different filter objects. This is to work around
 * the lack of an input union type.
 */
export type IAcademicCalendarFilterInput = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type IAcademicCalendarFormulas = {
  commitmentDate?: Maybe<ICalendarFormulaOutput>;
};

export type IAcademicCalendarInput = {
  academicPartnerId: Scalars['ID']['input'];
  /** If createdBy is not provided, it attempts to pull this from the jwt */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  published: Scalars['Boolean']['input'];
  skipFormulas?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar status (partial, draft, approved, etc..) */
  status: IAcademicCalendarStatus;
};

export type IAcademicCalendarListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of AcademicCalendars */
  data: Array<IAcademicCalendar>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export enum IAcademicCalendarStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

/** Academic Partner Core Object */
export type IAcademicPartner = {
  /** academic model - not the portal config type */
  academicModel: Scalars['String']['output'];
  academicPartnerId: Scalars['String']['output'];
  /** gives urls for logos and other assets */
  assetPaths?: Maybe<IAcademicPartnerAssetPaths>;
  /** Feature configurations organized by feature type */
  features?: Maybe<IAcademicPartnerFeaturesContainer>;
  /** UUID of specific Academic Partner */
  id: Scalars['ID']['output'];
  /** Identifies if this partner will be used for testing purposes only */
  isTest?: Maybe<Scalars['Boolean']['output']>;
  /** Long form name used to identify an Academic Partner */
  name: Scalars['String']['output'];
  /** portal config type with all data needed */
  portalConfig?: Maybe<IAcademicPartnerPortalConfig>;
  /** Shorter name (often an abbreviation) used to identify an Academic Partner */
  shortName: Scalars['String']['output'];
  /** Timestamp of last update */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Configuration to support Admissions and Lead Transfer (including Hybrid Pilot) */
export type IAcademicPartnerAdmissionsFeature = {
  accessLevel: IAccessLevelEnum;
  /** Does this partner have an admissions process? */
  hasAdmissions: Scalars['Boolean']['output'];
  /** Does students at this partner need to signal intent to enroll? */
  hasITE: Scalars['Boolean']['output'];
  /** Are the leads for this partner restricted by term? */
  hasTermRestrictedLeads: Scalars['Boolean']['output'];
  leadDataSource: ILeadDataSourceEnum;
  leadFileGeneration?: Maybe<Scalars['Boolean']['output']>;
  leadTemplateType?: Maybe<ILeadTemplateTypeEnum>;
  leadTransferOverSFTP: Scalars['Boolean']['output'];
  transferFrequency: ITransferFrequencyEnum;
};

/** Academic Partner asset data (urls, alt-text, etc) */
export type IAcademicPartnerAssetPaths = {
  /** Full url of the color logo */
  colorLogo?: Maybe<Scalars['String']['output']>;
  /** Alt text used for accessibility */
  logoAltText?: Maybe<Scalars['String']['output']>;
  /** Full url of the  black and white logo */
  whiteLogo?: Maybe<Scalars['String']['output']>;
};

/** General configuration details for an Academic Partner */
export type IAcademicPartnerCommonFeature = {
  employerIdentifierDisplayType: IEmployerIdentifierDisplayTypeEnum;
  /** Indicates if an academic partner has session terms from prior to the concept of Enrollment Periods (ACS V2) */
  hasHistoricalSessions?: Maybe<Scalars['Boolean']['output']>;
  /** How student id's should be displayed to this partner */
  learnerIdentifierDisplayType?: Maybe<ILearnerIdentifierDisplayTypeEnum>;
  /** The type of period the academic partner uses. */
  periodType?: Maybe<IPeriodTypeEnum>;
  portalModuleAccess: Array<IPortalModuleAccessEnum>;
};

export type IAcademicPartnerCreateInput = {
  academicModel: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  logoFiles: IAcademicPartnerLogoInput;
  name: Scalars['String']['input'];
  portalConfigId?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

/** General configuration details to support Eligibility */
export type IAcademicPartnerEligibilityFeature = {
  /** How frequently is eligibility information sent? */
  cadence: ICadenceEnum;
  eligibilityTypeCheck: Array<IEligibilityTypeCheckEnum>;
  /** When do we lock eligibility for this partner relative to term start? */
  lockDateCutOff: ILockDateCutOffEnum;
};

/** General configuration details to support enrollment services */
export type IAcademicPartnerEnrollmentsFeature = {
  /** The level at which Enrollment Verification is recognized for the given LP. */
  evGrain: IEvGrainEnum;
  /** True if the LP allows concurrent program enrollments. */
  hasConcurrentProgramEnrollments?: Maybe<Scalars['Boolean']['output']>;
  /** The LP should read from AES instead of legacy services (MMS/AS) - if UAT_ENABLED, continue sourcing from AS for API and data product. */
  readFromAES?: Maybe<IReadFromAesEnum>;
};

export type IAcademicPartnerErrorResponse = {
  errorMessage: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  /** AWS requestId */
  requestId?: Maybe<Scalars['String']['output']>;
};

/**
 * A Container containing feature specific configurations.
 * Often times, only a single key will be propogated upon responses,
 * especially as a result of a create or update to a specific feature.
 */
export type IAcademicPartnerFeaturesContainer = {
  admissions?: Maybe<IAcademicPartnerAdmissionsFeature>;
  common?: Maybe<IAcademicPartnerCommonFeature>;
  eligibility?: Maybe<IAcademicPartnerEligibilityFeature>;
  enrollments?: Maybe<IAcademicPartnerEnrollmentsFeature>;
  fileIngest?: Maybe<IAcademicPartnerFileIngestFeature>;
  paymentNetwork?: Maybe<IAcademicPartnerPaymentNetworkFeature>;
};

/** Configuration to support SFTP File Ingest */
export type IAcademicPartnerFileIngestFeature = {
  enabled?: Maybe<Scalars['Boolean']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  fileTypes: Array<IAcademicPartnerFileIngestFeatureFileTypesElement>;
};

export type IAcademicPartnerFileIngestFeatureFileTypesElement = {
  /** Override to indicate files have a different date format than default (necessary for some legacy partners) */
  customDateFormat?: Maybe<Scalars['String']['output']>;
  /** Override to describe location of file in files.com (necessary for legacy partners / non conforming partners) */
  defaultFilePathOverride?: Maybe<Scalars['String']['output']>;
  /** Whether or not this file type should be ingested */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not this file type is encrypted */
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  /** A file name pattern to match against in the SFTP drop box */
  fileNamePattern: Scalars['String']['output'];
  /** The destination folder in s3:/academic-pillar-<env>/ where the ingested file will be dropped */
  fileType: Scalars['String']['output'];
  /** Whether or not this file type is a test file */
  isTest?: Maybe<Scalars['Boolean']['output']>;
};

export type IAcademicPartnerListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of Partners */
  data: Array<IAcademicPartner>;
  /** List of errors */
  errors: Array<IAcademicPartnerErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type IAcademicPartnerLogoInput = {
  colorLogo?: InputMaybe<Scalars['String']['input']>;
  logoAltText?: InputMaybe<Scalars['String']['input']>;
  whiteLogo?: InputMaybe<Scalars['String']['input']>;
};

/** Configuration details to support payment networks */
export type IAcademicPartnerPaymentNetworkFeature = {
  /** Whether or not this institution allows deferred tuition */
  allowsDeferredTuition?: Maybe<Scalars['Boolean']['output']>;
  /** The contact email for this institution */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** The date the payment modality is effective */
  effectiveDate: Scalars['String']['output'];
  /** The date the payment modality ends */
  endDate?: Maybe<Scalars['String']['output']>;
  /** The employer IDs for exclusive employer partners */
  exclusiveEmployerPartnerIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The primary payment modality for this institution */
  primaryPaymentModality: IPrimaryPaymentModalityEnum;
  /** Whether or not this institution requires an opt-in */
  requiresOptIn?: Maybe<Scalars['Boolean']['output']>;
  /** The employer IDs for sponsoring employers */
  sponsoringEmployerIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The Stripe customer ID for this institution */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** The submission URL for this institution */
  submissionUrl?: Maybe<Scalars['String']['output']>;
  /** The payment modalities supported by this institution */
  supportsPaymentModalities: Array<ISupportsPaymentModalitiesEnum>;
  /** The type of tuition assistance partner for this institution */
  tuitionAssistancePartnerType?: Maybe<ITuitionAssistancePartnerTypeEnum>;
};

export type IAcademicPartnerPortalConfig = {
  configName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type IAcademicPartnerResponse = {
  /** Academic partner details */
  data?: Maybe<IAcademicPartner>;
  /** List of errors */
  errors: Array<IAcademicPartnerErrorResponse>;
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
};

export type IAcademicPartnerType = {
  active: Scalars['Boolean']['output'];
  colorLogoUrl: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  image: Scalars['String']['output'];
  informalName: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  logoAltText?: Maybe<Scalars['String']['output']>;
  logos: ILogosType;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['String']['output'];
  whiteLogoUrl: Scalars['String']['output'];
};

export type IAcademicPartnerUpdateInput = {
  academicModel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  logoFiles?: InputMaybe<IAcademicPartnerLogoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  portalConfigId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  updatedBy: Scalars['String']['input'];
};

export type IAcademicPeriod = {
  /** The billing periods attached to an academic period */
  academicBillingPeriods: Array<IBillingPeriod>;
  /** The Calendar id associated with this academic period */
  academicCalendarId: Scalars['ID']['output'];
  /** The last day of the academic period */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Has external calendar approval? */
  hasExternalCalendarApproval?: Maybe<Scalars['Boolean']['output']>;
  /** Has external exchange approval? */
  hasExternalExchangeApproval?: Maybe<Scalars['Boolean']['output']>;
  /** Has internal calendar approval? */
  hasInternalCalendarApproval?: Maybe<Scalars['Boolean']['output']>;
  /** Has internal exchange approval? */
  hasInternalExchangeApproval?: Maybe<Scalars['Boolean']['output']>;
  /** Unique UUID identifier */
  id: Scalars['ID']['output'];
  /** The name of a period, eg 'Spring 23' */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of the following Academic Period */
  nextAcademicPeriodId?: Maybe<Scalars['ID']['output']>;
  /** The first day of the academic period */
  startDate?: Maybe<Scalars['String']['output']>;
};

export type IAcademicPeriodApprovals = {
  /** Has external calendar approval? */
  hasExternalCalendarApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has external exchange approval? */
  hasExternalExchangeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has internal calendar approval? */
  hasInternalCalendarApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has internal exchange approval? */
  hasInternalExchangeApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IAcademicPeriodListResponse = {
  /** List of AcademicPeriods */
  data: Array<IAcademicPeriod>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
};

export type IAcademicResult = IBaseResult & {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  achievementType?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
  gpaActual?: Maybe<Scalars['Float']['output']>;
  gpaRule?: Maybe<Scalars['Float']['output']>;
  override?: Maybe<IOverride>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IAcademicStandards = {
  asOfDate: Scalars['String']['output'];
  coveragePackageId?: Maybe<Scalars['String']['output']>;
  employerId: Scalars['String']['output'];
  standards?: Maybe<IStandards>;
};

export enum IAccessLevelEnum {
  READ = 'read',
  READWRITE = 'readWrite',
}

/**
 * A level of an achievement in relationship to a program.
 * Ex: Language, College Start, High School, Bachelor's Degree
 */
export type IAchievementType = {
  /** unique identifier for the achievement type */
  id: Scalars['ID']['output'];
  /** Human readable name of the achievement type */
  name: Scalars['String']['output'];
};

/**
 * Enum used to describe old-style AchievementTypes.
 * _Note: `GuildPrograms` have not currently migrated to the database driven `AchievementType` at this time_
 */
export enum IAchievementTypeEnum {
  ASSOCIATEDEGREE = 'AssociateDegree',
  BACHELORSDEGREE = 'BachelorsDegree',
  CERTIFICATEORBOOTCAMP = 'CertificateOrBootcamp',
  COLLEGESTART = 'CollegeStart',
  DOCTORATEDEGREE = 'DoctorateDegree',
  HIGHSCHOOL = 'HighSchool',
  LANGUAGE = 'Language',
  MASTERSDEGREE = 'MastersDegree',
  UNKNOWN = 'Unknown',
}

export type IAcs_BatchProcessingError = {
  /** General category that the processing error falls into */
  category: IAcs_ErrorCategory;
  /** Specific error processing code */
  code: IAcs_ErrorCode;
  /** Level of processing error (ERROR or FATAL) */
  level: IAcs_ErrorLevel;
  /** Descriptive message of processing error */
  message: Scalars['String']['output'];
};

export type IAcs_BatchProcessingErrorWrapper = {
  /** Unique record identifier that was provided in request */
  correlationId?: Maybe<Scalars['ID']['output']>;
  /** Error details of processing error */
  error: IAcs_BatchProcessingError;
};

export enum IAcs_BatchProcessingOutcome {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
}

export enum IAcs_ErrorCategory {
  /** Errors related to Academic Partner verification */
  ACADEMIC_PARTNER = 'ACADEMIC_PARTNER',
  /** Errors related to date formatting and date range validations */
  DATE = 'DATE',
  /** General errors */
  ISSUE = 'ISSUE',
  /** Errors related to Parent/Session Term relationships */
  RELATIONSHIP = 'RELATIONSHIP',
}

export enum IAcs_ErrorCode {
  /** academicPartnerId could not be validated via Academic Partner Service */
  ACADEMIC_PARTNER_NOT_FOUND = 'ACADEMIC_PARTNER_NOT_FOUND',
  /** A given Session Term already exists in relation to a DIFFERENT Parent Term */
  DUPLICATE_SESSION = 'DUPLICATE_SESSION',
  /** Date format is invalid */
  INVALID_DATE = 'INVALID_DATE',
  /** A non-date input value is invalid */
  INVALID_INPUT = 'INVALID_INPUT',
  /** A given Parent Term could not be upserted because it already exists as a Session Term (i.e. no nested Sessions) */
  INVALID_PARENT = 'INVALID_PARENT',
  /** The min Session startDate and/or max Session endDate are outside the range of those of the Parent Term */
  SESSION_START_END_DATE_RANGE = 'SESSION_START_END_DATE_RANGE',
  /** The startDate is not before the endDate */
  START_END_DATE_RANGE = 'START_END_DATE_RANGE',
  /** Invalid term code (e.g. forbidden special characters) */
  TERM_CODE = 'TERM_CODE',
  /** Fallback for unhandled errors */
  UNKNOWN = 'UNKNOWN',
}

export enum IAcs_ErrorLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

export enum IAcsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type IAesResponse = {
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors?: Maybe<Array<IErrorResponse>>;
  /** Standard HTTP Status Code */
  statusCode: Scalars['Int']['output'];
};

/**
 * This is the error shape that should be utilized in the `error` property of
 * an operation's response (SomeResponse type).
 *
 * It is prefixed with Afo since this will be in the global gateway schema and if
 * another team overwrites this it will break everything.
 */
export type IAfoResponseError = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type IAnyUser = {
  archivedMemberUserId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type IApplication = {
  academicPartnerUuid?: Maybe<Scalars['ID']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  educationProfile?: Maybe<IEducationProfile>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  eligibleAt?: Maybe<Scalars['String']['output']>;
  enrollmentHistory?: Maybe<Array<Maybe<IEnrollmentIntentionHistoryEvent>>>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  programUuid?: Maybe<Scalars['ID']['output']>;
  responses?: Maybe<Array<Maybe<IApplicationResponse>>>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
};

export type IApplicationResponse = {
  agreementContent?: Maybe<Scalars['JSON']['output']>;
  formFieldId: Scalars['ID']['output'];
  formId: Scalars['ID']['output'];
};

export type IApplicationResult = IBaseResult & {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  approvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
  override?: Maybe<IOverride>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IApProgramCode = {
  /** Program Code Idenfifier provided by AP */
  apProgramCode: Scalars['String']['output'];
  /** PartnerProgram Idenfifier */
  apProgramId?: Maybe<Scalars['String']['output']>;
  /** non-primary codes are often the result of aliases or typos */
  isPrimary: Scalars['Boolean']['output'];
  /** true when only used for internal testing */
  isTest: Scalars['Boolean']['output'];
};

export type IApsFilterInput = {
  academicModel?: InputMaybe<Scalars['String']['input']>;
  configName?: InputMaybe<Scalars['String']['input']>;
  excludeNullConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTests?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IApsOrderByInput = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type IApsPaginationInput = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type IAs_Program = {
  academicPartnerId: Scalars['String']['output'];
  achievementType?: Maybe<Scalars['String']['output']>;
  concentrationId?: Maybe<Scalars['String']['output']>;
  concentrationName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['AWSJSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerProgramId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IAs_ProgramEnrollment = {
  academicPartnerId?: Maybe<Scalars['String']['output']>;
  academicPartnerName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditsEarned?: Maybe<Scalars['Float']['output']>;
  cumulativeGpa?: Maybe<Scalars['Float']['output']>;
  detail?: Maybe<Scalars['AWSJSON']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  guildProgramUuid?: Maybe<Scalars['ID']['output']>;
  guildUuid?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  partnerProgramId?: Maybe<Scalars['String']['output']>;
  partnerStudentId: Scalars['String']['output'];
  program?: Maybe<IAs_Program>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IAsyncResponse = {
  asyncRequestId: Scalars['ID']['output'];
  channelName: Scalars['String']['output'];
  data: Scalars['AWSJSON']['output'];
};

export type IAttributes = {
  deferred_tuition_allowed?: Maybe<Scalars['Boolean']['output']>;
  funding_limit?: Maybe<Scalars['Int']['output']>;
  is_additional_funding?: Maybe<Scalars['Boolean']['output']>;
  optimization_available?: Maybe<Scalars['Boolean']['output']>;
  reimbursement_available?: Maybe<Scalars['Boolean']['output']>;
  rollovers_allowed?: Maybe<Scalars['Boolean']['output']>;
};

export type IAuthor = {
  accentColors?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export type IBalance = {
  amountRemainingCents?: Maybe<Scalars['Int']['output']>;
  amountSpentCents: Scalars['Int']['output'];
  amountTuitionSpentCents: Scalars['Int']['output'];
  capAsOf: Scalars['String']['output'];
  spendAsOf: Scalars['String']['output'];
  tuitionFundingLimitCents?: Maybe<Scalars['Int']['output']>;
};

export type IBaseResult = {
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
};

export type IBatchPartnerProgramProcessingInput = {
  apProgramCode: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};

export type IBatchPartnerProgramResults = {
  academicPartnerId: Scalars['ID']['output'];
  batchRequestId: Scalars['ID']['output'];
  details: Array<IPartnerProgramProcessingResponse>;
  errors: Array<IBatchProcessingErrorWrapper>;
  successCount: Scalars['Int']['output'];
};

export type IBatchProcessingBillingPeriodResponse = {
  /** BillingPeriod data that was processed */
  billingPeriod: IBillingPeriod;
  /** Unique record identifier that was provided in request */
  correlationId?: Maybe<Scalars['ID']['output']>;
};

export type IBatchProcessingError = {
  category: IErrorCategory;
  code: IErrorCode;
  level: IErrorLevel;
  message: Scalars['String']['output'];
};

export type IBatchProcessingErrorWrapper = {
  error: IBatchProcessingError;
  requestId: Scalars['ID']['output'];
};

export type IBatchProcessingTermResponse = {
  /** Unique record identifier that was provided in request */
  correlationId?: Maybe<Scalars['ID']['output']>;
  /** Upsert outcome of processed record (CREATED or UPDATED) */
  outcome: IAcs_BatchProcessingOutcome;
  /** Term data that was processed */
  term: ITerm;
};

export type IBenefitOverviewConfig = {
  dpp_tax_grossup?: Maybe<ITaxGrossupStatus>;
  resources?: Maybe<Array<Maybe<IResource>>>;
  ta_tax_grossup?: Maybe<ITaxGrossupStatus>;
  tr_tax_grossup?: Maybe<ITaxGrossupStatus>;
};

export type IBenefitOverviewSimplified = {
  benefit_overview_config: IBenefitOverviewConfig;
  extra_funding_options?: Maybe<Array<Maybe<IExtraFundingOption>>>;
  funding_options?: Maybe<Array<Maybe<IFundingOption>>>;
};

export type IBenefitOverviewSummary = {
  benefit_overview_config: IBenefitOverviewConfig;
  coverage_summaries: Array<ICoverageSummary>;
  eligibility_summary: IEligibilitySummaryBenefitOverview;
};

export type IBetaUser = {
  email: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  employer: IBetaUserEmployer;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<IBetaUserRole>>;
};

export type IBetaUserEmployer = {
  employerId: Scalars['String']['output'];
  employerName: Scalars['String']['output'];
};

export type IBetaUserIds = {
  employeeId: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
};

export type IBetaUserRole = {
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

export type IBillingPeriod = {
  academicPartnerId: Scalars['String']['output'];
  academicPeriodId: Scalars['String']['output'];
  assessedTuitionFinalDate: Scalars['String']['output'];
  code: Scalars['String']['output'];
  eligibilityLockDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  enrollmentPeriods: Array<IEnrollmentPeriod>;
  epCreditMemoAppDate?: Maybe<Scalars['String']['output']>;
  epCreditMemoDate?: Maybe<Scalars['String']['output']>;
  epServiceFeeInvoiceDate: Scalars['String']['output'];
  epServiceFeePaymentDate: Scalars['String']['output'];
  epTuitionInvoiceDate: Scalars['String']['output'];
  epTuitionPaymentDate: Scalars['String']['output'];
  financialFileDate: Scalars['String']['output'];
  gradesFileDate: Scalars['String']['output'];
  guildPaysTuitionDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prelimEligibilityDate: Scalars['String']['output'];
  reconFileDate: Scalars['String']['output'];
  reconInvoiceDate: Scalars['String']['output'];
  reconPaymentDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type IBillingPeriodCohort = {
  academicPartner: IAcademicPartner;
  billingPeriod: ITerm;
  billingType: IBillingPeriodCohortBillingType;
  id: Scalars['ID']['output'];
  state: IBillingPeriodCohortState;
};

export enum IBillingPeriodCohortBillingType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION',
}

export enum IBillingPeriodCohortState {
  FAILED_QA = 'FAILED_QA',
  PASSED_QA = 'PASSED_QA',
  RELEASED = 'RELEASED',
  RELEASED_WITH_OVERRIDE = 'RELEASED_WITH_OVERRIDE',
  REVIEW_REQUESTED = 'REVIEW_REQUESTED',
  UNEVALUATED = 'UNEVALUATED',
}

export type IBillingPeriodCohortStateFailed = {
  message: Scalars['String']['output'];
};

export type IBillingPeriodCohortStateUpdated = {
  billingPeriodCohort: IBillingPeriodCohort;
};

export type IBillingPeriodCohortStateUpdateResult =
  | IBillingPeriodCohortStateFailed
  | IBillingPeriodCohortStateUpdated;

export type IBillingPeriodListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of BillingPeriods */
  data: Array<IBillingPeriod>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type IBillingPeriodsFilters = {
  academicPartnerId: Scalars['String']['input'];
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IBillingPeriodsOrderBySortInput = {
  /** Name of Term field */
  name: IBillingPeriodSortField;
  /** Sort order (ASC or DESC) */
  sort?: InputMaybe<IAcsSortOrder>;
};

export enum IBillingPeriodSortField {
  CODE = 'code',
  ID = 'id',
  NAME = 'name',
}

export type IBillingPeriodWrapper = {
  /** BillingPeriod data */
  billingPeriod: IBulkInsertBillingPeriodInput;
  /** Unique record identifier that will be returned in response (optional) */
  correlationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum IBillingUnit {
  PERCREDIT = 'PerCredit',
  PERTERM = 'PerTerm',
}

export type IBookmarkType = {
  program?: Maybe<IProgramType>;
  programId?: Maybe<Scalars['Int']['output']>;
  userUuid: Scalars['ID']['output'];
};

export type IBulkInsertBillingPeriodInput = {
  academicPeriodId: Scalars['ID']['input'];
  assessedTuitionFinalDate?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  eligibilityLockDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriods: Array<IBulkInsertEnrollmentPeriodInput>;
  epCreditMemoAppDate?: InputMaybe<Scalars['String']['input']>;
  epCreditMemoDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeeInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeePaymentDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionPaymentDate?: InputMaybe<Scalars['String']['input']>;
  financialFileDate?: InputMaybe<Scalars['String']['input']>;
  gradesFileDate?: InputMaybe<Scalars['String']['input']>;
  guildPaysTuitionDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prelimEligibilityDate?: InputMaybe<Scalars['String']['input']>;
  reconFileDate?: InputMaybe<Scalars['String']['input']>;
  reconInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  reconPaymentDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IBulkInsertBillingPeriodsResponse = {
  /** Unique identifier that was provided in request */
  batchCorrelationId?: Maybe<Scalars['ID']['output']>;
  /** List of processing errors */
  errors?: Maybe<Array<IAcs_BatchProcessingErrorWrapper>>;
  /** List of billing period responses that were successfully processed */
  responseList?: Maybe<Array<IBatchProcessingBillingPeriodResponse>>;
};

export type IBulkInsertEnrollmentPeriodInput = {
  code: Scalars['String']['input'];
  commitmentDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  expectedEnrollmentFileDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating one or more billing periods, with one or more enrollment periods attached */
export type IBulkInsertInput = {
  /** UUID for Academic Partner */
  academicPartnerId: Scalars['ID']['input'];
  /** Unique identifier for bulk request (optional) */
  batchCorrelationId?: InputMaybe<Scalars['ID']['input']>;
  /** If createdBy is not provided, it is pulled from the jwt */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Set to true for test data (optional) */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of billingPeriod records to be created */
  records: Array<IBillingPeriodWrapper>;
};

export enum ICadenceEnum {
  DAILY = 'daily',
  TERM_START = 'term_start',
}

export type ICalendarFormula = {
  amount: Scalars['Int']['input'];
  operation: ICalendarFormulaOperation;
  unit: ICalendarFormulaUnit;
};

export enum ICalendarFormulaOperation {
  ADD = 'Add',
  SUBTRACT = 'Subtract',
}

export type ICalendarFormulaOutput = {
  amount: Scalars['Int']['output'];
  operation: ICalendarFormulaOperation;
  unit: ICalendarFormulaUnit;
};

export enum ICalendarFormulaUnit {
  DAY = 'Day',
  FIRSTOFMONTH = 'FirstOfMonth',
  WEEKDAY = 'Weekday',
}

export type ICareerResources = {
  downloadableFile?: Maybe<Scalars['AWSURL']['output']>;
  externalLink?: Maybe<Scalars['AWSURL']['output']>;
};

export type ICensusCount = {
  eligibleCount: Scalars['Int']['output'];
  ineligibleCount: Scalars['Int']['output'];
};

export type ICensusResponse = {
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  result?: Maybe<ICensusResult>;
};

export type ICensusResult = {
  census: Array<ICensusCount>;
  effective: Scalars['AWSDateTime']['output'];
  employerId: Scalars['ID']['output'];
};

/** A child field of study. */
export type IChildFieldOfStudy = {
  /** Whether or not the parent field of study is legacy. A signal to consumers of deprecation. */
  active: Scalars['Boolean']['output'];
  /**
   * CIP Code (Classification of Instructural Program) for the field of study. For more information see https://nces.ed.gov/ipeds/cipcode/Default.aspx?y=56.
   * One to one relationship with a field of study.
   */
  cipCode: Scalars['String']['output'];
  /** stable unique identifier for the field of study */
  id: Scalars['ID']['output'];
  /** Human readable name of the field of study */
  name: Scalars['String']['output'];
  /** Parent Field of Study entity to this child (with children omitted to prevent circular references). */
  parent: INestedParentFieldOfStudy;
};

export type ICoachingLinks = {
  careerCoachingLink?: Maybe<Scalars['String']['output']>;
  growthCoachingLink?: Maybe<Scalars['String']['output']>;
};

export type ICommitProgramMappingsResponse = {
  errors: Array<Maybe<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type IContactStrategy = {
  contactType: Scalars['Int']['output'];
  contactTypeName: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ICorporateResult = IBaseResult & {
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
  expires?: Maybe<Scalars['AWSDate']['output']>;
  overrides?: Maybe<Array<Maybe<IOverride>>>;
};

export type ICourseEnrollment = {
  commitmentDate?: Maybe<Scalars['AWSDate']['output']>;
  correlationId?: Maybe<Scalars['ID']['output']>;
  credits: Scalars['Float']['output'];
  droppedBeforeAddDrop?: Maybe<Scalars['Boolean']['output']>;
  droppedDate?: Maybe<Scalars['AWSDate']['output']>;
  effectiveStart: Scalars['AWSDate']['output'];
  endDate?: Maybe<Scalars['AWSDate']['output']>;
  enrollmentVerification?: Maybe<IEnrollmentVerification>;
  externalCourseCode: Scalars['String']['output'];
  externalCourseIdentifier: Scalars['String']['output'];
  externalCourseName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalStudentId?: Maybe<Scalars['String']['output']>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastExamDate?: Maybe<Scalars['String']['output']>;
  numberOfExamsCompleted?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  periodEnrollment?: Maybe<IPeriodEnrollment>;
  recordedAt: Scalars['String']['output'];
  recordedBy: Scalars['String']['output'];
  section?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['AWSDate']['output'];
  status?: Maybe<IEnrollmentStatus>;
  totalNumberOfExams?: Maybe<Scalars['Int']['output']>;
};

export type ICourseEnrollmentListResponse = IAesResponse & {
  /** Data contains the response value */
  data?: Maybe<IPaginatedCourseEnrollments>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Standard HTTP Status Code */
  statusCode: Scalars['Int']['output'];
};

export type ICourseEnrollmentsByBillingPeriodInput = {
  options: ICourseEnrollmentsByBillingPeriodOptions;
  orderBy?: InputMaybe<Array<IOrderByInputCourseEnrollment>>;
  pagination?: InputMaybe<IPaginationInput>;
};

export type ICourseEnrollmentsByBillingPeriodOptions = {
  billingPeriodId: Scalars['String']['input'];
};

export type ICourseEnrollmentsByGuildUuidInput = {
  options: ICourseEnrollmentsByGuildUuidOptions;
  orderBy?: InputMaybe<Array<IOrderByInputCourseEnrollment>>;
  pagination?: InputMaybe<IPaginationInput>;
};

export type ICourseEnrollmentsByGuildUuidOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']['input']>;
  effectiveStart?: InputMaybe<Scalars['String']['input']>;
  guildUuid: Scalars['String']['input'];
};

export type ICoveragePackages = {
  academic?: Maybe<Array<Maybe<IAcademicResult>>>;
  application?: Maybe<Array<Maybe<IApplicationResult>>>;
  corporate?: Maybe<ICorporateResult>;
  coveragePackageId: Scalars['ID']['output'];
  program?: Maybe<Array<Maybe<IProgramResult>>>;
};

export type ICoverageSummaries = {
  coverage_summaries: Array<ICoverageSummary>;
};

export type ICoverageSummary = {
  categories: Array<Maybe<IEligibilitySummaryCategory>>;
  products: Array<Maybe<IProduct>>;
  status: ICoverageSummaryStatus;
};

export enum ICoverageSummaryStatus {
  AVAILABLE = 'AVAILABLE',
  LOST = 'LOST',
  UPCOMING = 'UPCOMING',
}

export type ICoveredExpense = {
  expense_type_id: Scalars['String']['output'];
  expense_type_name: Scalars['String']['output'];
  funding_limit?: Maybe<Scalars['Int']['output']>;
  is_additional_funding: Scalars['Boolean']['output'];
};

/** Input type for creating Academic Period */
export type ICreateAcademicPeriodInput = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nextAcademicPeriodId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating Billing Period */
export type ICreateBillingPeriodInput = {
  academicPartnerId: Scalars['ID']['input'];
  academicPeriodId: Scalars['ID']['input'];
  assessedTuitionFinalDate?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  eligibilityLockDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  epCreditMemoAppDate?: InputMaybe<Scalars['String']['input']>;
  epCreditMemoDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeeInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeePaymentDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionPaymentDate?: InputMaybe<Scalars['String']['input']>;
  financialFileDate?: InputMaybe<Scalars['String']['input']>;
  gradesFileDate?: InputMaybe<Scalars['String']['input']>;
  guildPaysTuitionDate?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  prelimEligibilityDate?: InputMaybe<Scalars['String']['input']>;
  reconFileDate?: InputMaybe<Scalars['String']['input']>;
  reconInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  reconPaymentDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ICreateEnrollmentPeriodInput = {
  academicPartnerId: Scalars['String']['input'];
  billingPeriodId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  commitmentDate?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  expectedEnrollmentFileDate?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ICreateSpendResponse = {
  adjustment?: Maybe<IFunding_Adjustment>;
  createSpendSummary?: Maybe<ICreateSpendSummary>;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type ICreateSpendSummary = {
  fundingLimitCents?: Maybe<Scalars['Int']['output']>;
  remainingBalanceCents?: Maybe<Scalars['Int']['output']>;
};

export type ICriteria = {
  acceptedValue?: Maybe<Scalars['AWSJSON']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  employeeValue?: Maybe<Scalars['AWSJSON']['output']>;
  name: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  tenureDays?: Maybe<Scalars['Float']['output']>;
};

export type ICycMemberProgress = {
  feedback?: Maybe<ICycMemberProgressFeedback>;
  memberUuid: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<ICycMemberProgressStatus>;
  webinyEntryId: Scalars['String']['output'];
};

export enum ICycMemberProgressFeedback {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
}

export enum ICycMemberProgressStatus {
  COMPLETED = 'COMPLETED',
}

export type IDashboard = {
  entryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<IModule>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IDataset = {
  active?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  employerUUID?: Maybe<Scalars['ID']['output']>;
  filePattern?: Maybe<Scalars['String']['output']>;
  fileVersions?: Maybe<Array<Maybe<IFileVersion>>>;
  itemAssociation?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<IDatasetStatus>;
  type?: Maybe<IDatasetType>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum IDatasetStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum IDatasetType {
  C4X = 'c4x',
  EMPLOYEE = 'employee',
  PAYMENTS = 'payments',
}

export type IDeleteMemberUserAuth0Input = {
  auth0Id: Scalars['String']['input'];
};

export type IDeletePartnerProgramInput = {
  deletedBy: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type IDeletePartnerProgramResponse = {
  errors: Array<Maybe<IAfoResponseError>>;
  success: Scalars['Boolean']['output'];
  updated: Array<Maybe<IPartnerProgram>>;
};

export type IDirectPay = IPaymentModalitySupport & {
  contactEmail?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  exclusiveEmployerPartnerIds?: Maybe<Array<Scalars['String']['output']>>;
  requiresOptIn: Scalars['Boolean']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  submissionUrl?: Maybe<Scalars['String']['output']>;
  type: IPaymentModalityType;
};

export type IDirectPaymentProgramInformationData = {
  sponsorshipTimelineDays?: Maybe<Scalars['Int']['output']>;
  tuitionAmount?: Maybe<Scalars['Int']['output']>;
};

export type IEducationProfile = {
  birthday?: Maybe<Scalars['Date']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditsEarned?: Maybe<IOption>;
  cumulativeCollegeGpa?: Maybe<Scalars['Float']['output']>;
  cumulativeHighSchoolGpa?: Maybe<Scalars['Float']['output']>;
  current: Scalars['Boolean']['output'];
  educationLevel?: Maybe<IOption>;
  email: Scalars['String']['output'];
  ethnicity: Array<IOption>;
  firstLanguage?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<IOption>;
  genderSelfDescribe?: Maybe<Scalars['String']['output']>;
  homeAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  militaryService?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalState?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  schoolsAttended: Array<ISchoolAttendance>;
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
  workState?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type IEligibilibityPreviewResponse = {
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  result?: Maybe<IEligibilityPreviewResult>;
};

export type IEligibilityAndCoverageSummaries = {
  coverage_summaries: Array<ICoverageSummary>;
  eligibility_summary: IEligibilitySummary;
};

export type IEligibilityPreviewResult = {
  current?: Maybe<IEligibilityPreviewRulesResult>;
  effective: Scalars['AWSDateTime']['output'];
  eligible: Scalars['Boolean']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['ID']['output']>;
  preview?: Maybe<IEligibilityPreviewRulesResult>;
};

export type IEligibilityPreviewRulesResult = {
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
};

export type IEligibilityResult = {
  coveragePackages: Array<ICoveragePackages>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type IEligibilitySummary = {
  categories: Array<Maybe<IEligibilitySummaryCategory>>;
  eligible: Scalars['Boolean']['output'];
  employer_contact_information?: Maybe<IEmployerEligibilityContactInformation>;
  metadata?: Maybe<IMetadata>;
  status: IEligibilitySummaryStatus;
};

export type IEligibilitySummaryBenefitOverview = {
  metadata?: Maybe<IMetadata>;
};

export type IEligibilitySummaryCategory = {
  category_description?: Maybe<Scalars['String']['output']>;
  category_tag: Scalars['String']['output'];
  category_title?: Maybe<Scalars['String']['output']>;
  status: IEligibilitySummaryCategoryStatus;
};

export enum IEligibilitySummaryCategoryStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  UNKNOWN = 'UNKNOWN',
}

export enum IEligibilitySummaryStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  LOST = 'LOST',
  NULL_PLAN = 'NULL_PLAN',
  UPCOMING = 'UPCOMING',
}

export enum IEligibilityType {
  ACADEMICPERFORMANCE = 'AcademicPerformance',
  CORPORATE = 'Corporate',
  ENROLLMENT = 'Enrollment',
}

export enum IEligibilityTypeCheckEnum {
  ACADEMIC = 'academic',
  CORPORATE = 'corporate',
  PARTNER = 'partner',
}

export type IEmployee = {
  employeeId: Scalars['String']['output'];
  employerId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type IEmployeeLookupResult = {
  employees?: Maybe<Array<Maybe<IEmployee>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type IEmployer = {
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  eciSupported: Scalars['Boolean']['output'];
  guildPartnershipStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IEmployerConfig = {
  careerResources?: Maybe<ICareerResources>;
  coachingEnabled?: Maybe<Scalars['Boolean']['output']>;
  employerUuid?: Maybe<Scalars['String']['output']>;
};

export type IEmployerEligibilityContactInformation = {
  email?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<IEmployer>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

export enum IEmployerIdentifierDisplayTypeEnum {
  EMPLOYERNAME = 'employerName',
  EMPLOYERUUID = 'employerUuid',
  NONE = 'none',
}

export type IEmployerInfo = {
  asOf?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerResources?: Maybe<Array<Maybe<IEmployerResources>>>;
  errors?: Maybe<Array<Maybe<IEmployerPolicyServiceError>>>;
  platformReadyDate?: Maybe<Scalars['AWSDateTime']['output']>;
  termPlural?: Maybe<Scalars['String']['output']>;
  termSingular?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IEmployerInfoPublicResources = {
  asOf?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  employerId?: Maybe<Scalars['ID']['output']>;
  employerResources?: Maybe<Array<Maybe<IEmployerResources>>>;
  errors?: Maybe<Array<Maybe<IEmployerPolicyServiceError>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IEmployerInstitution = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentModalities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryPaymentModalityType?: Maybe<Scalars['String']['output']>;
};

export type IEmployerInstitutions = {
  employerId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<Maybe<IEmployerPolicyServiceError>>>;
  institutions?: Maybe<Array<Maybe<IEmployerInstitution>>>;
};

export type IEmployerPolicy = {
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  effective?: Maybe<Scalars['AWSDateTime']['output']>;
  employerId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  policy?: Maybe<Scalars['AWSJSON']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<IEmployerPolicyStatus>;
  type?: Maybe<IEmployerPolicyType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  versionDescription?: Maybe<Scalars['String']['output']>;
  versionName?: Maybe<Scalars['String']['output']>;
};

export type IEmployerPolicyCreateInput = {
  effective: Scalars['AWSDate']['input'];
  employerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  policy?: InputMaybe<Scalars['AWSJSON']['input']>;
  requestedBy: Scalars['String']['input'];
  type: Scalars['String']['input'];
  versionDescription: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};

export type IEmployerPolicyListResponse = {
  errors: Array<IEmployerPolicyServiceError>;
  results: Array<IEmployerPolicy>;
};

export type IEmployerPolicyResponse = {
  errors?: Maybe<Array<Maybe<IEmployerPolicyServiceError>>>;
  result?: Maybe<IEmployerPolicy>;
};

export type IEmployerPolicyServiceError = {
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum IEmployerPolicyStatus {
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  LIVE = 'LIVE',
}

export enum IEmployerPolicyType {
  DEPENDENT = 'DEPENDENT',
  EMPLOYEE = 'EMPLOYEE',
  UNION = 'UNION',
}

export type IEmployerPolicyUpdateInput = {
  effective: Scalars['AWSDate']['input'];
  employerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  policy: Scalars['AWSJSON']['input'];
  requestedBy: Scalars['String']['input'];
  type: Scalars['String']['input'];
  versionDescription: Scalars['String']['input'];
  versionName: Scalars['String']['input'];
};

export type IEmployerResources = {
  accessType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type IEmployerResourcesInput = {
  accessType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
  valueType: Scalars['String']['input'];
};

export type IEmployerStandardsResponse = {
  /** Data contains the response value */
  data?: Maybe<Array<IAcademicStandards>>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
};

export type IEnabledType = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum IEncryptionAlgorithm {
  EDDSA = 'EDDSA',
  RSA4096 = 'RSA4096',
}

export type IEnrollmentDataIngestError = {
  academicPartnerId: Scalars['ID']['output'];
  dataSource: Scalars['String']['output'];
  errorCode: IEnrollmentDataIngestFailureCode;
  errorLevel: IEnrollmentDataIngestFailureLevel;
  errorMessage: Scalars['String']['output'];
  executionTime: Scalars['String']['output'];
  fieldName?: Maybe<Scalars['String']['output']>;
  fileProcessType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<IEnrollmentDataIngestErrorMetadata>;
  recordedAt: Scalars['String']['output'];
};

export type IEnrollmentDataIngestErrorMetadata = {
  enrollmentPeriodCode?: Maybe<Scalars['String']['output']>;
  externalProgramCode?: Maybe<Scalars['String']['output']>;
  externalStudentIdentifier?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  guildExternalId?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['Int']['output']>;
  studentCurrentGpa?: Maybe<Scalars['String']['output']>;
  studentTotalCredits?: Maybe<Scalars['String']['output']>;
};

export enum IEnrollmentDataIngestFailureCode {
  DUPLICATE001 = 'DUPLICATE001',
  EV001 = 'EV001',
  EXTERNAL001 = 'EXTERNAL001',
  FORMAT001 = 'FORMAT001',
  FORMAT002 = 'FORMAT002',
  FORMAT003 = 'FORMAT003',
  FORMAT004 = 'FORMAT004',
  FORMAT005 = 'FORMAT005',
  FORMAT006 = 'FORMAT006',
  FORMAT007 = 'FORMAT007',
  GEN001 = 'GEN001',
  MISSING002 = 'MISSING002',
  MISSING003 = 'MISSING003',
  MISSING004 = 'MISSING004',
  MISSING005 = 'MISSING005',
  TERM001 = 'TERM001',
  TERM002 = 'TERM002',
  TERM003 = 'TERM003',
  TERM004 = 'TERM004',
  TERM005 = 'TERM005',
  UNKNOWNENTITY001 = 'UNKNOWNENTITY001',
  UNKNOWNENTITY003 = 'UNKNOWNENTITY003',
  UNKNOWNENTITY004 = 'UNKNOWNENTITY004',
  UNKNOWNENTITY006 = 'UNKNOWNENTITY006',
  UNKNOWNENTITY008 = 'UNKNOWNENTITY008',
  UNKNOWNENTITY014 = 'UNKNOWNENTITY014',
  UNKNOWNENTITY015 = 'UNKNOWNENTITY015',
  UNKNOWNENTITY016 = 'UNKNOWNENTITY016',
}

export enum IEnrollmentDataIngestFailureLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING',
}

export enum IEnrollmentIngestProcessingStatus {
  CLEAN = 'CLEAN',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  INFECTED = 'INFECTED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
  SCANNING = 'SCANNING',
  SKIP = 'SKIP',
  UNKNOWN = 'UNKNOWN',
}

export type IEnrollmentIntentionHistoryEvent = {
  enrollmentUuid?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intendsToEnroll?: Maybe<Scalars['Boolean']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  recordedAt?: Maybe<Scalars['Date']['output']>;
  term?: Maybe<IEnrollmentIntentionHistoryTerm>;
};

export type IEnrollmentIntentionHistoryTerm = {
  code?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type IEnrollmentPeriod = {
  academicPartnerId: Scalars['String']['output'];
  billingPeriod?: Maybe<IBillingPeriod>;
  code: Scalars['String']['output'];
  commitmentDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  expectedEnrollmentFileDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type IEnrollmentPeriodListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of EnrollmentPeriods */
  data: Array<IEnrollmentPeriod>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type IEnrollmentPeriodsFilters = {
  academicPartnerId: Scalars['String']['input'];
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IEnrollmentPeriodsOrderBySortInput = {
  /** Name of Term field */
  name: IEnrollmentPeriodSortField;
  /** Sort order (ASC or DESC) */
  sort?: InputMaybe<IAcsSortOrder>;
};

export enum IEnrollmentPeriodSortField {
  CODE = 'code',
  ID = 'id',
  NAME = 'name',
}

export enum IEnrollmentStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  INACTIVE = 'INACTIVE',
}

export type IEnrollmentVerification = {
  enrollmentVerificationDate: Scalars['AWSDate']['output'];
  grain: IEnrollmentVerificationGrain;
  id: Scalars['ID']['output'];
  isEnrollmentVerified: Scalars['Boolean']['output'];
  periodEnrollment: IPeriodEnrollment;
  recordedAt: Scalars['String']['output'];
  recordedBy: Scalars['String']['output'];
  recordEndDate: Scalars['AWSDate']['output'];
  recordStartDate: Scalars['AWSDate']['output'];
  state: IEnrollmentVerificationState;
};

export enum IEnrollmentVerificationGrain {
  COURSE = 'COURSE',
  PROGRAM = 'PROGRAM',
}

export enum IEnrollmentVerificationState {
  NO_EV = 'NO_EV',
  PENDING = 'PENDING',
  REVERSED = 'REVERSED',
  VERIFIED = 'VERIFIED',
}

export type IEpPortalUser = {
  active?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  employeeId: Scalars['ID']['output'];
  employerId: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export enum IErrorCategory {
  GENERAL = 'GENERAL',
}

export enum IErrorCode {
  DUPLICATE = 'DUPLICATE',
  INVALIDINPUT = 'INVALIDINPUT',
  NOTFOUND = 'NOTFOUND',
}

export enum IErrorLevel {
  ERROR = 'ERROR',
  FATAL = 'FATAL',
  WARNING = 'WARNING',
}

export type IErrorResponse = {
  /** ErrorCode is an enum of error codes in AES */
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  /** The name of the field associated with the error message */
  fieldName?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
};

export enum IEvGrainEnum {
  COURSE = 'COURSE',
  PROGRAM = 'PROGRAM',
}

export type IExchangeDateFormula = {
  /** Academic Partner UUID */
  academicPartnerId: Scalars['ID']['output'];
  /** Calendar ID */
  calendarId: Scalars['ID']['output'];
  /** Exchange Date Type ID */
  exchangeDateTypeId: Scalars['ID']['output'];
  /** Unique identifier UUID */
  id: Scalars['ID']['output'];
  /** Offset formula text */
  offsetFormula: Scalars['String']['output'];
};

export type IExpectedExchangeDateFormulas = {
  enrollmentFile?: Maybe<ICalendarFormulaOutput>;
  epTuitionPayment?: Maybe<ICalendarFormulaOutput>;
  financialFile?: Maybe<ICalendarFormulaOutput>;
  gradeFile?: Maybe<ICalendarFormulaOutput>;
  reconFile?: Maybe<ICalendarFormulaOutput>;
  serviceFeeInvoice?: Maybe<ICalendarFormulaOutput>;
  serviceFeePayment?: Maybe<ICalendarFormulaOutput>;
  tuitionReconPayment?: Maybe<ICalendarFormulaOutput>;
};

export type IExtraFundingOption = {
  enabled_types?: Maybe<Array<Maybe<IEnabledType>>>;
  funding_limit?: Maybe<Scalars['String']['output']>;
  name: INonStandardProductName;
  optimization_available?: Maybe<Scalars['Boolean']['output']>;
  status_tag: IProductStatusTag;
};

export type IFederatedErrorResponse = {
  errorMessage: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
};

export type IField = {
  active: Scalars['Boolean']['output'];
  availableValues?: Maybe<Scalars['AWSJSON']['output']>;
  createdDate: Scalars['AWSDateTime']['output'];
  dataFormat?: Maybe<Scalars['String']['output']>;
  distinctValues?: Maybe<Scalars['Int']['output']>;
  employerUUID: Scalars['ID']['output'];
  exampleValue?: Maybe<Scalars['String']['output']>;
  filledRows?: Maybe<Scalars['Int']['output']>;
  itemAssociation?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  suggestedDataType?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
};

/**
 * A filter flag to pass when getting many fields of study.
 * Active - All active fields of study
 * Inactive - All inactive fields of study
 * All - All fields of study, regardless of active status
 */
export enum IFieldsOfStudyFilter {
  ACTIVE = 'Active',
  ALL = 'All',
  INACTIVE = 'Inactive',
}

/**
 * Input fields for Field of Study, allows for:
 * Filters: Active, All, Inactive
 */
export type IFieldsOfStudyInput = {
  filter: IFieldsOfStudyFilter;
};

export type IFileVersion = {
  active: Scalars['Boolean']['output'];
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
  employerUUID?: Maybe<Scalars['ID']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['AWSDate']['output']>;
  fields?: Maybe<Array<Maybe<IField>>>;
  headers?: Maybe<Scalars['AWSJSON']['output']>;
  itemAssociation?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['AWSDate']['output']>;
  status?: Maybe<IDatasetStatus>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IFinancialIngestValidationResultsRequest = {
  filters?: InputMaybe<IFinancialValidationResultsFilters>;
  ingestGroupId: Scalars['ID']['input'];
};

export type IFinancialReleaseValidationResultsRequest = {
  billingPeriodCohortId: Scalars['ID']['input'];
  filters?: InputMaybe<IFinancialValidationResultsFilters>;
};

export enum IFinancialValidationCategory {
  ENROLLMENT = 'ENROLLMENT',
  FORMAT = 'FORMAT',
  GENERAL = 'GENERAL',
  INVALID = 'INVALID',
  MONETARY = 'MONETARY',
  STUDENT = 'STUDENT',
  TERM = 'TERM',
}

export enum IFinancialValidationCode {
  ADMISSION002 = 'ADMISSION002',
  DUPLICATE001 = 'DUPLICATE001',
  DUPLICATE002 = 'DUPLICATE002',
  DUPLICATE003 = 'DUPLICATE003',
  FIN_DUPLICATE001 = 'FIN_DUPLICATE001',
  FIN_FORMAT001 = 'FIN_FORMAT001',
  FIN_FORMAT002 = 'FIN_FORMAT002',
  FIN_FORMAT003 = 'FIN_FORMAT003',
  FIN_FORMAT004 = 'FIN_FORMAT004',
  FIN_GEN001 = 'FIN_GEN001',
  FIN_GEN002 = 'FIN_GEN002',
  FIN_INVALIDCHAR001 = 'FIN_INVALIDCHAR001',
  FIN_INVALIDCHAR003 = 'FIN_INVALIDCHAR003',
  FIN_MISSING002 = 'FIN_MISSING002',
  FIN_TERM001 = 'FIN_TERM001',
  FIN_TERM006 = 'FIN_TERM006',
  FIN_TUITION001 = 'FIN_TUITION001',
  FIN_TUITION002 = 'FIN_TUITION002',
  FIN_TXENROLL001 = 'FIN_TXENROLL001',
  FIN_TXENROLL002 = 'FIN_TXENROLL002',
  FIN_UNKNOWNENTITY007 = 'FIN_UNKNOWNENTITY007',
  FIN_UNKNOWNENTITY010 = 'FIN_UNKNOWNENTITY010',
  FORMAT001 = 'FORMAT001',
  FORMAT002 = 'FORMAT002',
  FORMAT003 = 'FORMAT003',
  FORMAT004 = 'FORMAT004',
  GEN001 = 'GEN001',
  GEN002 = 'GEN002',
  GEN003 = 'GEN003',
  INVALIDCHAR001 = 'INVALIDCHAR001',
  INVALIDCHAR002 = 'INVALIDCHAR002',
  INVALIDCHAR003 = 'INVALIDCHAR003',
  INVALIDCHAR004 = 'INVALIDCHAR004',
  MISSING001 = 'MISSING001',
  MISSING002 = 'MISSING002',
  MISSING003 = 'MISSING003',
  TERM001 = 'TERM001',
  TERM002 = 'TERM002',
  TERM003 = 'TERM003',
  TERM004 = 'TERM004',
  TERM005 = 'TERM005',
  TERM006 = 'TERM006',
  TUITION001 = 'TUITION001',
  TUITION002 = 'TUITION002',
  UNKNOWN010 = 'UNKNOWN010',
  UNKNOWNENTITY003 = 'UNKNOWNENTITY003',
  UNKNOWNENTITY006 = 'UNKNOWNENTITY006',
  UNKNOWNENTITY007 = 'UNKNOWNENTITY007',
  UNKNOWNENTITY008 = 'UNKNOWNENTITY008',
  UNKNOWNENTITY009 = 'UNKNOWNENTITY009',
  UNKNOWNENTITY010 = 'UNKNOWNENTITY010',
  UNKNOWNENTITY012 = 'UNKNOWNENTITY012',
  UNKNOWNENTITY013 = 'UNKNOWNENTITY013',
}

export type IFinancialValidationMetadata = {
  fieldName?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  guildExternalId?: Maybe<Scalars['ID']['output']>;
  lineNumber?: Maybe<Scalars['Int']['output']>;
  partnerStudentId?: Maybe<Scalars['ID']['output']>;
  termCode?: Maybe<Scalars['String']['output']>;
};

export type IFinancialValidationResult = {
  category: IFinancialValidationCategory;
  code: IFinancialValidationCode;
  level: IErrorLevel;
  message: Scalars['String']['output'];
  metadata: IFinancialValidationMetadata;
  outcome: IFinancialValidationResultOutcome;
};

export enum IFinancialValidationResultOutcome {
  FAIL = 'FAIL',
}

export type IFinancialValidationResultsFilters = {
  resultOutcomes?: InputMaybe<Array<InputMaybe<IFinancialValidationResultOutcome>>>;
};

export type IFolder = {
  employerUUID: Scalars['ID']['output'];
  files: Array<ISampleFile>;
  location: IFolderLocation;
  name: Scalars['String']['output'];
  type: IFolderType;
};

export enum IFolderLocation {
  DIRECTUPLOAD = 'DirectUpload',
  SFTP = 'SFTP',
}

export enum IFolderType {
  PRODUCTION = 'production',
  TEST = 'test',
}

export type IFunding_AdditionalColumns = {
  employee?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IFunding_Adjustment = {
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type IFunding_AdjustmentValidationError = {
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type IFunding_BenefitPeriodsResponse = {
  asOf: Scalars['AWSDate']['output'];
  endsAfter: Scalars['AWSDate']['output'];
  id: Scalars['ID']['output'];
  sequence: IFunding_Sequence;
  startsOn: Scalars['AWSDate']['output'];
};

export type IFunding_BulkAdjustmentsResponse = {
  error?: Maybe<Scalars['String']['output']>;
  invalidAdjustments: Array<Maybe<IFunding_ValidatedAdjustment>>;
  validAdjustments: Array<Maybe<IFunding_ValidatedAdjustment>>;
};

export type IFunding_BulkCreateCustomBenefitConfigurationError = {
  error?: Maybe<Scalars['String']['output']>;
  guildUuid?: Maybe<Scalars['ID']['output']>;
};

export type IFunding_BulkCreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  assignedBy: Scalars['ID']['input'];
  category: IFunding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID']['input'];
  endsAfter: Scalars['AWSDate']['input'];
  fundingLimits: Array<InputMaybe<IFunding_CustomFundingLimitInput>>;
  guildUuids: Array<Scalars['ID']['input']>;
  metadata: Scalars['AWSJSON']['input'];
  reason: Scalars['String']['input'];
  startsOn: Scalars['AWSDate']['input'];
};

export type IFunding_BulkCreateCustomBenefitConfigurationResponse = {
  failures?: Maybe<Array<Maybe<IFunding_BulkCreateCustomBenefitConfigurationError>>>;
  successes?: Maybe<Array<Maybe<IFunding_CustomBenefitConfiguration>>>;
};

export type IFunding_BulkGetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
  keys: Array<IFunding_BulkGetSpendByProductKey>;
  product: IFunding_Product;
  spendAsOf: Scalars['AWSDate']['input'];
};

export type IFunding_BulkGetSpendByProductKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  memberId: Scalars['ID']['input'];
};

export type IFunding_BulkGetSpendByProductResponse = {
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  members?: Maybe<Array<IFunding_BulkGetSpendByProductResponseMember>>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_BulkGetSpendByProductResponseMember = {
  capAsOf?: Maybe<Scalars['AWSDate']['output']>;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  fundingBalances?: Maybe<Array<Maybe<IFunding_GetSpendFundingBalance>>>;
  memberId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_BulkGetStudentSpendAchievementTypeRequestKey = {
  achievementType: Scalars['String']['input'];
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
  guildUuid: Scalars['ID']['input'];
};

export type IFunding_BulkGetStudentSpendByAchievementType = {
  audience?: InputMaybe<Scalars['String']['input']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  keys: Array<IFunding_BulkGetStudentSpendAchievementTypeRequestKey>;
  origin?: InputMaybe<Scalars['String']['input']>;
  product: IFunding_Product;
  spendAsOf: Scalars['AWSDate']['input'];
};

export type IFunding_BulkGetStudentSpendByProgramId = {
  audience?: InputMaybe<Scalars['String']['input']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  keys: Array<IFunding_BulkGetStudentSpendProgramIdRequestKey>;
  origin?: InputMaybe<Scalars['String']['input']>;
  product: IFunding_Product;
  spendAsOf: Scalars['AWSDate']['input'];
};

export type IFunding_BulkGetStudentSpendProgramIdRequestKey = {
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  guildUuid: Scalars['ID']['input'];
  programUuid: Scalars['ID']['input'];
};

export type IFunding_BulkUpdateTaxPeriodsInput = {
  employerId: Scalars['ID']['input'];
  taxPeriods?: InputMaybe<Array<InputMaybe<IFunding_UpdateTaxPeriods>>>;
};

export type IFunding_BulkUpdateTaxPeriodsResponse = {
  updatedTaxPeriods?: Maybe<Array<Maybe<IFunding_CreateTaxPeriodResponse>>>;
};

export type IFunding_CoveragePackageIdUserEligibilityResult = {
  academic?: Maybe<Array<Maybe<IFunding_EligibilityAcademicResult>>>;
  application?: Maybe<Array<Maybe<IFunding_EligibilityApplicationResult>>>;
  corporate?: Maybe<IFunding_EligibilityCorporateResult>;
  coveragePackageId?: Maybe<Scalars['ID']['output']>;
  program?: Maybe<Array<Maybe<IFunding_EligibilityProgramResult>>>;
};

export type IFunding_CreateAdjustmentInput = {
  academicInstitutionName?: InputMaybe<Scalars['String']['input']>;
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  amountCents: Scalars['Int']['input'];
  benefitLockedOn: Scalars['AWSDate']['input'];
  committedAt: Scalars['AWSDateTime']['input'];
  employerId: Scalars['ID']['input'];
  expenseTypeId: Scalars['ID']['input'];
  guildUuid: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  isCrossYear?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  origin: Scalars['String']['input'];
  originApplicationId?: InputMaybe<Scalars['String']['input']>;
  originProduct?: InputMaybe<Scalars['String']['input']>;
  originRecordId: Scalars['String']['input'];
  originRecordName: Scalars['String']['input'];
  payor?: InputMaybe<IFunding_Payor>;
  product: IFunding_Product;
};

export type IFunding_CreateAdjustmentsFromFileInput = {
  asyncRequestId?: InputMaybe<Scalars['ID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  expenseTypeId?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  originProduct?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<IFunding_Product>;
  reason?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Scalars['String']['input']>;
};

export type IFunding_CreateCustomBenefitConfigurationInput = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  assignedBy: Scalars['ID']['input'];
  category: IFunding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID']['input'];
  endsAfter: Scalars['AWSDate']['input'];
  fundingLimits: Array<InputMaybe<IFunding_CustomFundingLimitInput>>;
  guildUuid: Scalars['ID']['input'];
  metadata: Scalars['AWSJSON']['input'];
  reason: Scalars['String']['input'];
  startsOn: Scalars['AWSDate']['input'];
};

export type IFunding_CreateSpend = {
  academicInstitutionName?: InputMaybe<Scalars['String']['input']>;
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  allowCapOverage?: InputMaybe<Scalars['Boolean']['input']>;
  amountCents: Scalars['Int']['input'];
  benefitLockedOn: Scalars['String']['input'];
  capAsOf: Scalars['String']['input'];
  committedAt: Scalars['String']['input'];
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  expenseTypeId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  isCrossYear?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  origin: Scalars['String']['input'];
  originApplicationId?: InputMaybe<Scalars['String']['input']>;
  originProduct?: InputMaybe<Scalars['String']['input']>;
  originRecordId: Scalars['String']['input'];
  originRecordName: Scalars['String']['input'];
  payor?: InputMaybe<IFunding_Payor>;
  product: IFunding_Product;
  productContext?: InputMaybe<IProductContext>;
};

export type IFunding_CreateTaxPeriodInput = {
  employerId: Scalars['ID']['input'];
  endsAfter: Scalars['AWSDate']['input'];
  startsOn: Scalars['AWSDate']['input'];
};

export type IFunding_CreateTaxPeriodResponse = {
  endsAfter: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nextTaxPeriod?: Maybe<Scalars['ID']['output']>;
  startsOn: Scalars['String']['output'];
};

export type IFunding_CustomBenefitConfiguration = {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  assignedBy: Scalars['ID']['output'];
  category: IFunding_CustomBenefitConfigurationCategory;
  createdAt: Scalars['AWSDateTime']['output'];
  employerId: Scalars['ID']['output'];
  endsAfter: Scalars['AWSDate']['output'];
  fundingLimits?: Maybe<Array<Maybe<IFunding_CustomFundingLimit>>>;
  guildUuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['AWSJSON']['output'];
  reason: Scalars['String']['output'];
  startsOn: Scalars['AWSDate']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum IFunding_CustomBenefitConfigurationCategory {
  FALLBACK = 'fallback',
  MODIFY = 'modify',
  OVERRIDE = 'override',
}

export type IFunding_CustomFundingLimit = {
  expenseTypes: Array<Maybe<Scalars['String']['output']>>;
  fundingLimitCents?: Maybe<Scalars['Int']['output']>;
  fundingLimitId?: Maybe<Scalars['String']['output']>;
  includedInTuition: Scalars['Boolean']['output'];
};

export type IFunding_CustomFundingLimitInput = {
  expenseTypes: Array<Scalars['String']['input']>;
  fundingLimitCents?: InputMaybe<Scalars['Int']['input']>;
  includedInTuition?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IFunding_DateRange = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type IFunding_DateTimeRange = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type IFunding_EligibilityAcademicResult = {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  achievementType?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Array<Maybe<IFunding_EligibilityCriteria>>>;
  eligible: Scalars['Boolean']['output'];
  gpaActual?: Maybe<Scalars['Float']['output']>;
  gpaRule?: Maybe<Scalars['Float']['output']>;
  override?: Maybe<IFunding_EligibilityOverride>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IFunding_EligibilityApplicationResult = {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  approvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  criteria?: Maybe<Array<Maybe<IFunding_EligibilityCriteria>>>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IFunding_EligibilityCorporateResult = {
  criteria?: Maybe<Array<Maybe<IFunding_EligibilityCriteria>>>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  overrides?: Maybe<Array<Maybe<IFunding_EligibilityOverride>>>;
};

export type IFunding_EligibilityCriteria = {
  acceptedValue?: Maybe<Scalars['AWSJSON']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employeeValue?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
  tenureDays?: Maybe<Scalars['Float']['output']>;
};

export type IFunding_EligibilityInformation = {
  applicationId?: Maybe<Scalars['String']['output']>;
  eligibilityDetails?: Maybe<Array<Maybe<IFunding_CoveragePackageIdUserEligibilityResult>>>;
  programId?: Maybe<Scalars['String']['output']>;
};

export type IFunding_EligibilityOverride = {
  effectiveEndDate: Scalars['AWSDateTime']['output'];
  effectiveStartDate: Scalars['AWSDateTime']['output'];
  originalOutcome: Scalars['Boolean']['output'];
  overrideOutcome: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

export type IFunding_EligibilityProgramResult = {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  criteria?: Maybe<Array<Maybe<IFunding_EligibilityCriteria>>>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IFunding_ExpenseTypeLimit = {
  expenseTypeId: Scalars['ID']['output'];
  expenseTypeName: Scalars['String']['output'];
  fundingLimitAmountCents?: Maybe<Scalars['Int']['output']>;
  spentAmountCents: Scalars['Int']['output'];
};

export type IFunding_GenerateLearnerSpendReport = {
  additionalColumns?: InputMaybe<IFunding_AdditionalColumns>;
  bypassCrossYearReversals?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  filter?: InputMaybe<IFunding_ReportFilter>;
  includeGuildUuid?: InputMaybe<Scalars['Boolean']['input']>;
  inNetworkTR?: InputMaybe<Scalars['Boolean']['input']>;
  productFilters?: InputMaybe<IFunding_ProductFilters>;
  type: IFunding_LearnerSpendReportType;
};

export type IFunding_GenerateLearnerSpendReportResponse = {
  error?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type IFunding_GetAdjustmentFileUploadUrlInput = {
  fileName: Scalars['String']['input'];
};

export type IFunding_GetBenefitPeriodsByEmployerIdInput = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IFunding_GetBenefitPeriodsByEmployerIdResponse = {
  benefitPeriods?: Maybe<Array<Maybe<IFunding_BenefitPeriodsResponse>>>;
};

export type IFunding_GetCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  asOf: Scalars['AWSDate']['input'];
  category: IFunding_CustomBenefitConfigurationCategory;
  employerId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};

export type IFunding_GetCustomBenefitConfigurationResponse = {
  data?: Maybe<IFunding_CustomBenefitConfiguration>;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_GetLearnerSpendReportUrlInput = {
  fileName: Scalars['String']['input'];
};

export type IFunding_GetLearningSpendReportUrlResponse = {
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_GetSpendByProductInput = {
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
  product: IFunding_Product;
  spendAsOf: Scalars['AWSDate']['input'];
};

export type IFunding_GetSpendByProductResponse = {
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  fundingBalances?: Maybe<Array<Maybe<IFunding_GetSpendFundingBalance>>>;
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_GetSpendFundingBalance = {
  expenseTypeLimits?: Maybe<Array<Maybe<IFunding_ExpenseTypeLimit>>>;
  fundingDescription?: Maybe<Scalars['String']['output']>;
  fundingLimitAmountCents?: Maybe<Scalars['Int']['output']>;
  spentAmountCents: Scalars['Int']['output'];
};

export type IFunding_GetStudentSpend = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  achievementType?: InputMaybe<Scalars['String']['input']>;
  audience?: InputMaybe<Scalars['String']['input']>;
  capAsOf?: InputMaybe<Scalars['AWSDate']['input']>;
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
  guildUuid: Scalars['ID']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  partnerStudentId?: InputMaybe<Scalars['String']['input']>;
  product: IFunding_Product;
  programUuid?: InputMaybe<Scalars['ID']['input']>;
  spendAsOf: Scalars['AWSDate']['input'];
};

export type IFunding_GetStudentSpendResponse = {
  balance: IStudent_Balance;
  debug: IStudent_Balance_Debug;
  eligibilityInformation?: Maybe<IFunding_EligibilityInformation>;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_GetTaxPeriodsInput = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IFunding_GetTaxPeriodsResponse = {
  taxPeriods?: Maybe<Array<Maybe<IFunding_TaxPeriod>>>;
  warning?: Maybe<Scalars['String']['output']>;
};

export enum IFunding_LearnerSpendReportType {
  EMPLOYEE = 'EMPLOYEE',
  FAMILY_MEMBER = 'FAMILY_MEMBER',
  NEGATIVE_CROSS_YEAR = 'NEGATIVE_CROSS_YEAR',
}

export type IFunding_ListAdjustment = {
  academicInstitutionName?: Maybe<Scalars['String']['output']>;
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  amountCents: Scalars['Int']['output'];
  benefitLockedOn: Scalars['String']['output'];
  committedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  employerId: Scalars['ID']['output'];
  expenseTypeId: Scalars['ID']['output'];
  grossUpEligibility?: Maybe<Scalars['String']['output']>;
  guildUuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  isCrossYear?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  origin: Scalars['String']['output'];
  originRecordId: Scalars['String']['output'];
  originRecordName: Scalars['String']['output'];
  payor?: Maybe<IFunding_Payor>;
  product?: Maybe<Scalars['String']['output']>;
  taxSection?: Maybe<Scalars['String']['output']>;
};

export type IFunding_ListAdjustments = {
  benefitLockedOn?: InputMaybe<IFunding_DateRange>;
  committedAt?: InputMaybe<IFunding_DateRange>;
  createdAt?: InputMaybe<IFunding_DateTimeRange>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  expenseTypeId?: InputMaybe<Scalars['ID']['input']>;
  guildUuid?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payor?: InputMaybe<IFunding_Payor>;
  product?: InputMaybe<IFunding_Product>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IFunding_ListAdjustmentsResponse = {
  adjustments?: Maybe<Array<Maybe<IFunding_ListAdjustment>>>;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  page?: Maybe<IFunding_Page>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_ListLearnerSpendReportsInput = {
  employerId: Scalars['ID']['input'];
  year: Scalars['String']['input'];
};

export type IFunding_ListLearnerSpendReportsResponse = {
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  files?: Maybe<Array<Maybe<IS3FileMetadata>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IFunding_Page = {
  currentPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum IFunding_Payor {
  EMPLOYER = 'employer',
  GUILD = 'guild',
}

export type IFunding_PresignedFileUrl = {
  fields: Scalars['AWSJSON']['output'];
  url: Scalars['String']['output'];
};

export enum IFunding_Product {
  EXTERNAL = 'EXTERNAL',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES',
  SPONSORSHIP = 'SPONSORSHIP',
  STUDENT_LOAN_BENEFIT = 'STUDENT_LOAN_BENEFIT',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT',
}

export type IFunding_ProductFilters = {
  balanceTransfer?: InputMaybe<IFunding_ReportFilter>;
  sponsorship?: InputMaybe<IFunding_ReportFilter>;
  studentLoanReimbursement?: InputMaybe<IFunding_ReportFilter>;
  tuitionAssistance?: InputMaybe<IFunding_ReportFilter>;
  tuitionReimbursement?: InputMaybe<IFunding_ReportFilter>;
};

export type IFunding_ReportFilter = {
  benefitLockedOn?: InputMaybe<IFunding_DateRange>;
  committedAt?: InputMaybe<IFunding_DateRange>;
  taxEligibleOn?: InputMaybe<IFunding_DateRange>;
};

export enum IFunding_Sequence {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  NEXT = 'NEXT',
  OLDER = 'OLDER',
  PREVIOUS = 'PREVIOUS',
}

export type IFunding_Service_Error = {
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IFunding_Service_Warning = {
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type IFunding_StudentSpendResponseWithGuildUuidAndAchievementType = {
  achievementType: Scalars['ID']['output'];
  balance: IStudent_Balance;
  debug: IStudent_Balance_Debug;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  fieldOfStudyId?: Maybe<Scalars['ID']['output']>;
  guildUuid: Scalars['ID']['output'];
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_StudentSpendResponseWithGuildUuidAndProgramId = {
  balance: IStudent_Balance;
  debug: IStudent_Balance_Debug;
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  guildUuid: Scalars['ID']['output'];
  programUuid: Scalars['ID']['output'];
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_TaxPeriod = {
  asOf: Scalars['AWSDate']['output'];
  endsAfter: Scalars['AWSDate']['output'];
  id: Scalars['ID']['output'];
  sequence: IFunding_Sequence;
  startsOn: Scalars['AWSDate']['output'];
};

export type IFunding_UpdateCustomBenefitConfiguration = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  assignedBy: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  customBenefitConfigurationId: Scalars['ID']['input'];
  employerId?: InputMaybe<Scalars['ID']['input']>;
  endsAfter?: InputMaybe<Scalars['AWSDate']['input']>;
  fundingLimits?: InputMaybe<Array<InputMaybe<IFunding_CustomFundingLimitInput>>>;
  guildUuid?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startsOn?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type IFunding_UpdateTaxEligible = {
  adjustmentIds: Array<InputMaybe<Scalars['Int']['input']>>;
  originRecordId: Scalars['String']['input'];
  taxEligibleOn: Scalars['AWSDate']['input'];
  updatedBy: Scalars['ID']['input'];
};

export type IFunding_UpdateTaxEligibleResponse = {
  errors?: Maybe<Array<Maybe<IFunding_Service_Error>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<Maybe<IFunding_Service_Warning>>>;
};

export type IFunding_UpdateTaxPeriods = {
  endsAfter: Scalars['AWSDate']['input'];
  id: Scalars['ID']['input'];
  startsOn: Scalars['AWSDate']['input'];
};

export type IFunding_ValidatedAdjustment = {
  academicInstitutionName?: Maybe<Scalars['String']['output']>;
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  amountCents?: Maybe<Scalars['String']['output']>;
  benefitLockedOn?: Maybe<Scalars['AWSDate']['output']>;
  errors?: Maybe<Array<Maybe<IFunding_AdjustmentValidationError>>>;
  guildUuid?: Maybe<Scalars['ID']['output']>;
  isCrossYear?: Maybe<Scalars['Boolean']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  originApplicationId?: Maybe<Scalars['String']['output']>;
  originRecordId?: Maybe<Scalars['String']['output']>;
  originRecordName?: Maybe<Scalars['String']['output']>;
  payor?: Maybe<Scalars['String']['output']>;
};

export type IFundingDetail = {
  achievement_types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fields_of_study?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  funding_limit: Scalars['String']['output'];
  program_count: Scalars['Int']['output'];
  status_tag: IProductStatusTag;
};

export type IFundingOption = {
  books_and_fees_included: Scalars['Boolean']['output'];
  deferred_tuition_allowed: Scalars['Boolean']['output'];
  funding_details?: Maybe<Array<Maybe<IFundingDetail>>>;
  name: IStandardProductName;
};

export type IFundingPackage = {
  achievement_types: Array<Maybe<Scalars['String']['output']>>;
  benefit_package_id?: Maybe<Scalars['String']['output']>;
  covered_expenses?: Maybe<Array<Maybe<ICoveredExpense>>>;
  fields_of_study?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  program_count?: Maybe<Scalars['Int']['output']>;
  tuition_funding_limit?: Maybe<Scalars['String']['output']>;
};

export type IFundingResultInformationData = {
  DirectPaymentProgramInformationData?: Maybe<IDirectPaymentProgramInformationData>;
  TuitionAssistanceInformationData?: Maybe<ITuitionAssistanceInformationData>;
  TuitionReimbursementInformationData?: Maybe<ITuitionReimbursementInformationData>;
};

export type IGetActiveRuleResponse = {
  /** Data contains the response value */
  data?: Maybe<IRule>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
};

export type IGetEnrollmentIngestProcessingStatusResponse = IAesResponse & {
  /** List of errors that include error type, message and request ID */
  errors?: Maybe<Array<IErrorResponse>>;
  /** Status enum for file upload */
  status: IEnrollmentIngestProcessingStatus;
  /** Status code */
  statusCode: Scalars['Int']['output'];
};

export type IGpaMinimum = {
  associatesDegree?: Maybe<Scalars['Float']['output']>;
  bachelorsDegree?: Maybe<Scalars['Float']['output']>;
  certification?: Maybe<Scalars['Float']['output']>;
  highSchoolCompletion?: Maybe<Scalars['Float']['output']>;
  mastersDegree?: Maybe<Scalars['Float']['output']>;
  unknownAchievementType?: Maybe<Scalars['Float']['output']>;
};

export type IGuildProgram = {
  /** this will be populated via APS + global gateway */
  academicPartner?: Maybe<IAcademicPartner>;
  /**
   * a specific item in a selected list of various levels for schools
   * Language, High School, College Start, Associate Degree, Bachelors Degree, Masters Degree, Doctorate Degree, Certificate or Bootcamp.
   * **notice of breaking change: this will be replaced with the new AchievementType instead of the currently used Enum version at a later date**
   * @deprecated This field is deprecated. Use achievementTypeId instead.
   */
  achievementType?: Maybe<IAchievementTypeEnum>;
  /**
   * UUID of the `AchievementType`.
   * UUIDs for Language, High School, College Start, Associate Degree, Bachelors Degree, Masters Degree, Doctorate Degree, Certificate or Bootcamp.
   */
  achievementTypeId: Scalars['String']['output'];
  /** The corresponding `AchievementType`. */
  achievementTypes?: Maybe<IAchievementType>;
  /** timestamp when the record was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** userId that created this Program */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** unique identifier for the returned program. */
  id: Scalars['ID']['output'];
  /** true when only used for internal testing */
  isTest: Scalars['Boolean']['output'];
  /** this is the human readable name of the program in relation to the academic partner */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Offering Id associated with the Guild Program. This is predominately used in the catalog and has no direct Academic Pillar uses.
   * _Note: This is currently being sourced with a backend call to catalog service, but in the future could be propogated via type merging._
   */
  offeringId?: Maybe<Scalars['ID']['output']>;
  /**
   * This flag is indicative if this program is, once was, or is planning on being an offering in the catalog.
   * At present, offeringId's existance represents the same information, but this flag allows for flexibility in implementation of
   * "unmerchandized programs"
   */
  onCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** The related PartnerProgram records, nullable to support nested querying  - populated via nested querying (calls Query:partnerProgramsByGuildProgram with specific criteria) */
  partnerPrograms?: Maybe<Array<IPartnerProgram>>;
  /**
   * unique identifier for the returned program. Deprecated. Use id instead
   * @deprecated No longer supported
   */
  programId: Scalars['String']['output'];
  /** timestamp when the record was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** userId that last updated this Program */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type IGuildProgramPartnerProgramsArgs = {
  allDates?: InputMaybe<Scalars['Boolean']['input']>;
  futureDates?: InputMaybe<Scalars['Boolean']['input']>;
};

/** `GuildProgram` creation input values */
export type IGuildProgramCreateInput = {
  /** UUID of the `AchievementType`. */
  achievementTypeId: Scalars['String']['input'];
  /** Human readable string for the program. */
  guildProgramName: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** if updatedBy is not provided, it attempts to pull this from the authenticated user contained in the JWT. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filtering criteria when listing `GuildPrograms`.
 * Each provided filter further narrows the results (ie: using **AND** not OR)
 */
export type IGuildProgramListInput = {
  /** AcademicPartner UUID. */
  academicPartnerId?: InputMaybe<Scalars['String']['input']>;
  /** Filtering by the UUID of the `AchievementType`. */
  achievementTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Tests values are omitted by default, this flag includes them. */
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Boolean used to filter to only programs that are found in the catalog.
   * By default this is enabled.
   */
  onlyOnCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case insensitive search string on `GuildProgram.id` and `GuildProgram.name` */
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type IGuildProgramListResponse = {
  /** Max number of responses per page */
  count: Scalars['Int']['output'];
  /** List of `GuildPrograms` */
  data?: Maybe<Array<IGuildProgram>>;
  /** List of Error types and messages */
  errors: Array<IProgramErrorResponse>;
  /** The page the results come from, for pagination purposes. Starts at 1 */
  page: Scalars['Int']['output'];
  /**
   * Loosely based on RESTFUL status code values. Deprecated
   * @deprecated No longer supported
   */
  statusCode: Scalars['Int']['output'];
  /** Total count of records matching the filtering criteria */
  total: Scalars['Int']['output'];
  /** Total number of pages of this size that match the filtering criteria */
  totalPages: Scalars['Int']['output'];
};

export type IGuildProgramResponse = {
  /** Program details */
  data?: Maybe<IGuildProgram>;
  /** List of errors */
  errors: Array<IProgramErrorResponse>;
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
};

/** `GuildProgram` update input values */
export type IGuildProgramUpdateInput = {
  /** UUID of the `AchievementType`. */
  achievementTypeId?: InputMaybe<Scalars['String']['input']>;
  /** UUID for the `GuildProgram` to be updated */
  guildProgramId: Scalars['String']['input'];
  /** Human readable string for the program. */
  guildProgramName?: InputMaybe<Scalars['String']['input']>;
  /** if updatedBy is not provided, it attempts to pull this from the authenticated user contained in the JWT. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IHeartbeatResponse = {
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
};

export type IIdentity = {
  data?: Maybe<Array<Maybe<IProgramEnrollment>>>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  employerId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type IInstitution = {
  /**
   * Academic model - not the portal config type
   * Only used for DirectPay or TuitionAssistance payment modalities
   */
  academicModel?: Maybe<Scalars['String']['output']>;
  /** Gives urls for logos and other assets */
  assetPaths?: Maybe<IAcademicPartnerAssetPaths>;
  /** Timestamp of when the institution was created */
  createdAt: Scalars['String']['output'];
  /** UUID of specific Institution */
  id: Scalars['ID']['output'];
  /** Long form name used to identify an Institution */
  name: Scalars['String']['output'];
  /** Portal config type with all data needed */
  portalConfig?: Maybe<IAcademicPartnerPortalConfig>;
  /** The primary payment modality for this institution */
  primaryPaymentModalityType: IPaymentModalityType;
  /** Shorter name (often an abbreviation) used to identify an Institution */
  shortName: Scalars['String']['output'];
  /** The payment modalities supported by this institution */
  supportsPaymentModalities: Array<IPaymentModalitySupport>;
  /** Timestamp of last update, including any feature config changes */
  updatedAt: Scalars['String']['output'];
};

export type IInstitutionCreateInput = {
  academicModel?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  logoFiles?: InputMaybe<IAcademicPartnerLogoInput>;
  name: Scalars['String']['input'];
  portalConfigId?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
};

export type IInstitutionFilterInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryPaymentModalityType?: InputMaybe<IPaymentModalityType>;
  requiresOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  supportsExclusiveEmployerPartnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supportsPaymentModality?: InputMaybe<Array<InputMaybe<IPaymentModalityType>>>;
};

export type IInstitutionListResponse = {
  /** List of Partners */
  data: Array<IInstitution>;
  /** List of errors */
  errors: Array<IAcademicPartnerErrorResponse>;
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
};

export enum IInstitutionOrderByDirection {
  ASCEND = 'Ascend',
  DESCEND = 'Descend',
}

export enum IInstitutionOrderByField {
  ID = 'Id',
  SHORTNAME = 'ShortName',
}

export type IInstitutionPaginationInput = {
  count: Scalars['Int']['input'];
  direction: IInstitutionOrderByDirection;
  field: IInstitutionOrderByField;
  lastFieldInResults?: InputMaybe<Scalars['String']['input']>;
};

export type IInstitutionPaymentNetworkFeatureCreateInput = {
  allowsDeferredTuition?: InputMaybe<Scalars['Boolean']['input']>;
  billsDirectly?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  exclusiveEmployerPartnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryPaymentModality: IPaymentModalityType;
  requiresOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  sponsoringEmployerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  submissionUrl?: InputMaybe<Scalars['String']['input']>;
  supportsPaymentModalities: Array<IPaymentModalityType>;
  tuitionAssistancePartnerType?: InputMaybe<ITuitionAssistancePartnerType>;
};

export type IInstitutionResponse = {
  /** Institution details */
  data?: Maybe<IInstitution>;
  /** List of errors */
  errors: Array<IAcademicPartnerErrorResponse>;
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
};

export type IInstitutionUpdateInput = {
  academicModel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  logoFiles?: InputMaybe<IAcademicPartnerLogoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  portalConfigId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  updatedBy: Scalars['String']['input'];
};

export type IInternalUser = {
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ILatestBillingPeriodCohortsPerBillingTypeResponse = {
  latestFinancialBillingPeriodCohort?: Maybe<IBillingPeriodCohort>;
  latestReconciliationBillingPeriodCohort?: Maybe<IBillingPeriodCohort>;
};

export enum ILeadDataSourceEnum {
  ADMISSIONS = 'admissions',
  ATS = 'ats',
  LEADSSERVICE = 'leadsService',
  PORTAL = 'portal',
}

export enum ILeadTemplateTypeEnum {
  LEARNINGPARTNER = 'learningPartner',
  UNIVERSITYBASE = 'universityBase',
}

export enum ILearnerIdentifierDisplayTypeEnum {
  GUILDEXTERNALID = 'guildExternalId',
  GUILDUUID = 'guildUuid',
}

export enum ILearningMarketplaceAvailability {
  INELIGIBLE = 'INELIGIBLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
}

export type ILearningMarketplaceAvailabilityDecision = {
  availability: ILearningMarketplaceAvailability;
};

export type ILesson = {
  activity?: Maybe<ILesson_Activity>;
  author?: Maybe<IAuthor>;
  closingText?: Maybe<Scalars['AWSJSON']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instructionText?: Maybe<Scalars['AWSJSON']['output']>;
  instructionVideo?: Maybe<ILesson_InstructionVideo>;
  intro?: Maybe<Scalars['AWSJSON']['output']>;
  lessonType?: Maybe<Scalars['String']['output']>;
  maximumTimeToFinish?: Maybe<Scalars['Int']['output']>;
  minimumTimeToFinish?: Maybe<Scalars['Int']['output']>;
  pictogramActivity?: Maybe<IPictogram>;
  pictogramColor?: Maybe<Scalars['String']['output']>;
  pictogramLookingForward?: Maybe<IPictogram>;
  pictogramOverview?: Maybe<IPictogram>;
  theme?: Maybe<IThemeTag>;
  thumbnailImage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ILesson_Activity = {
  body?: Maybe<Scalars['AWSJSON']['output']>;
  level1?: Maybe<ILesson_Activity_Level1>;
  level2?: Maybe<ILesson_Activity_Level2>;
  level3?: Maybe<ILesson_Activity_Level3>;
};

export type ILesson_Activity_Level1 = {
  body?: Maybe<Scalars['AWSJSON']['output']>;
  file?: Maybe<Scalars['String']['output']>;
};

export type ILesson_Activity_Level2 = {
  body?: Maybe<Scalars['AWSJSON']['output']>;
  file?: Maybe<Scalars['String']['output']>;
};

export type ILesson_Activity_Level3 = {
  body?: Maybe<Scalars['AWSJSON']['output']>;
  file?: Maybe<Scalars['String']['output']>;
};

export type ILesson_InstructionVideo = {
  videoScriptUrl?: Maybe<Scalars['String']['output']>;
  videoThumbnailImage?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type IListEnrollmentDataIngestErrorsInput = {
  options: IListEnrollmentDataIngestErrorsOptions;
  pagination?: InputMaybe<IPaginationInput>;
};

export type IListEnrollmentDataIngestErrorsOptions = {
  academicPartnerId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  dataSource: Scalars['String']['input'];
};

export type IListEnrollmentDataIngestErrorsResponse = IAesResponse & {
  /** Data contains the response value */
  data?: Maybe<IPaginatedEnrollmentDataIngestErrors>;
  /** Errors is a list of Errors including the error type, message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Standard HTTP Status Code */
  statusCode: Scalars['Int']['output'];
};

export enum ILockDateCutOffEnum {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
}

export type ILogosType = {
  color?: Maybe<Scalars['String']['output']>;
  gray?: Maybe<Scalars['String']['output']>;
  white?: Maybe<Scalars['String']['output']>;
};

export type IMemberUser = {
  active?: Maybe<Scalars['Boolean']['output']>;
  applications?: Maybe<Array<IApplication>>;
  archivedIntoUserId?: Maybe<Scalars['ID']['output']>;
  archivedMemberUserFound?: Maybe<Scalars['Boolean']['output']>;
  coachingLinks?: Maybe<ICoachingLinks>;
  contactStrategies?: Maybe<Array<Maybe<IContactStrategy>>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  studentIdentities?: Maybe<Array<IStudentIdentity>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  userAuth0s?: Maybe<Array<Maybe<IMemberUserAuth0>>>;
};

export type IMemberUserAuth0 = {
  auth0Id: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type IMemberUsersFromExternalIdsResponse = {
  activeMemberUsers?: Maybe<Array<Maybe<IMemberUser>>>;
  archivedMemberUsers?: Maybe<Array<Maybe<IMemberUser>>>;
  notFoundExternalIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IMemberUsersResponse = {
  activeMemberUsers?: Maybe<Array<Maybe<IMemberUser>>>;
  archivedMemberUsers?: Maybe<Array<Maybe<IMemberUser>>>;
  notFoundMemberUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IMetadata = {
  tenure_days?: Maybe<Scalars['Int']['output']>;
};

export type IMicrosite = {
  createdAt?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  micrositeUrlSlug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IModule = {
  description?: Maybe<Scalars['String']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Array<Maybe<ILesson>>>;
  nextModule?: Maybe<IModule>;
  title?: Maybe<Scalars['String']['output']>;
  whenToTakeThisModule?: Maybe<Scalars['String']['output']>;
};

export type IMutation = {
  /**
   * Links an `ApProgramCode` to a `GuildProgram` by creating a `PartnerProgram`.
   * **Note: Program service converts dates to midnight mountain of the provided time.
   * In the event no timezone offset is provided, the time is considered to be Mountain time.**
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Errors:
   *   - ValidationError: startDate invalid date
   *   - ValidationError: startDate can not be in past
   *   - ValidationError: apProgramCode <apCode> is already attached to `PartnerProgram` <PartnerProgram.id>
   *
   * #### Events:
   *   - Triggers `pser-partner-program-created`
   *
   * #### Additional Notes:
   *   - The provided `ApProgramCode` must not already be linked to another `PartnerProgram`, but it can be unlinked.
   */
  addLinkedCode: IPartnerProgram;
  /**
   * Used to create an Unlinked code.
   * This will surface as a call to action for the user to remediate by:
   *   - aliasing to an existing PartnerProgram
   *   - linking this code to a `GuildProgram` (and thereby creating a new PartnerProgram)
   *   - deleting this unlinked code, in cases where neither action above is appropriate
   *
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Errors:
   *   - ValidationError: apProgramCode <apCode> already exists (link or alias code as appropriate)
   *
   * #### Events:
   *   - Triggers `pser-unlinked-ap-code-created`
   *
   * #### Additional Notes:
   *   - Unlinked code creation is not sufficient to store other data related to that record.
   *     Consumers should reject or quarantine data related to these codes until the appropriate action has been taken.
   */
  addUnlinkedCode: IApProgramCode;
  /**
   * Adds an new `ApProgramCode` to a `PartnerProgram`. By default, the new code will become the primary code.
   * Code aliasing should be used in cases only where one string representation and another string representation are
   * permanently linked and functionally interchangeable.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Errors:
   *     - ResourceNotFound: `PartnerProgram` not found
   *     - ValidationError: AP Program Code already exists and is linked
   *
   * #### Events:
   *   - Triggers `pser-ap-program-code-aliased`
   *
   * #### Additional Notes:
   *   - Some typical use cases:
   *     - alternative spellings
   *     - 'typos' that are intended to be persisted
   *     - Academic Partner changes their program naming scheme
   *   - This should **not** be the approach used to create new distinct PartnerPrograms, _even if these `PartnerPrograms` link to the same `GuildProgram`_
   *     - For example: `BS.MATH` and `BS.MATH.TRIG` and `BS.MATH.GEO` should each be distinctive `PartnerPrograms`, and not aliases to a single `PartnerProgram`
   */
  aliasCode: IPartnerProgram;
  anonymizeMemberUser?: Maybe<IMemberUser>;
  approveEmployerPolicy?: Maybe<IEmployerPolicyResponse>;
  approveRollcallAcademicPeriod: IAcademicPeriod;
  archiveEmployerPolicy?: Maybe<IEmployerPolicyResponse>;
  associateSampleFile?: Maybe<ISampleFile>;
  /**
   * This supports batch processing requests by ALPS to ingest legacy SFTP partner data
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:batchPartnerProgram` ]
   *
   * ##### audiences (m2m)
   * [ `https://graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   * ```
   * batchPartnerProgramProcessing( academicPartnerId: $academicPartnerId
   *       batchRequestId: $batchRequestId
   *       codeRequests: $codeRequests) {
   *           academicPartnerId
   *           batchRequestId
   *           successCount
   *           details {
   *               apProgramCode {
   *                   apProgramCode
   *                   isPrimary
   *                   isTest
   *               }
   *               outcome
   *               requestId
   *               error {
   *                   category
   *                   code
   *                   level
   *                   message
   *               }
   *           }
   *       }
   *   ```
   *
   * #### Errors:
   * Errors are handled in two ways:
   * 1. If there is a "top" level error that impacts the entirety of the file, it is added to the `error` list with the `requestId` set as the `batchRequestId` provided. These types of errors have a `FATAL` level.
   * 2. If there is an error for a specific request, that error is added to the `error`  list the with `requestId` set to the relevant `requestId` provided. These errors will also have requests appear in the `details` list with the `outcome` set to `ERROR`.
   *   a. Additionally, these errors may cause Appsync errors that can safely be ignored.
   * #### Events:
   *     - _None_
   * #### Additional Notes:
   * - any `CREATED` records are made as unlinked Program codes.
   */
  batchPartnerProgramProcessing: IBatchPartnerProgramResults;
  /** Bulk Insert one or more Billing Periods with one or more Enrollment Periods attached to each */
  bulkInsertBillingPeriods: IBulkInsertBillingPeriodsResponse;
  changePrice: IPriceMutationResponse;
  /**
   * This endpoint receives a Base64 encoded string that is expected to be a CSV file input.
   * The input will then be read and persisted to the database.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildSuperUser`, `guildAdmin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:guildSuperUser`, `PS:guildAdmin` ]
   *
   * ##### audiences (m2m)
   * [ `https://program-service.guildeducation.com`, `graphql-gateway.guild-cloud.com`, `https://frontend.guild-cloud.com` ]
   *
   * #### Example: TODO
   * #### Errors: TODO
   * #### Events:: TODO
   * #### Additional Notes:
   */
  commitProgramMappings: ICommitProgramMappingsResponse;
  /** Create an AcademicCalendar */
  createAcademicCalendar: IAcademicCalendar;
  /** Creates a new AcademicPeriod based on the provided input. */
  createAcademicPeriod: IAcademicPeriod;
  createAP: IAcademicPartnerResponse;
  /** Creates a new BillingPeriod based on the provided input. */
  createBillingPeriod: IBillingPeriod;
  createDataset?: Maybe<IDataset>;
  createEmployerPolicy?: Maybe<IEmployerPolicyResponse>;
  createEncryptionKeys?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a new EnrollmentPeriod based on the provided input. */
  createEnrollmentPeriod: IEnrollmentPeriod;
  /** Create a Exchange Date Formula */
  createExchangeDateFormula: IExchangeDateFormula;
  createFileVersion?: Maybe<IFileVersion>;
  /**
   * Creates a new GuildProgram.
   *
   * #### Authorization:
   *
   * _roles_:
   *   - guildAdmin
   *   - guildSuperUser
   *   - bat-admin
   *
   * _scopes (m2m)_:
   *   - PS:write:partner-program
   *
   * _audiences (m2m)_:
   *   - https://graphql-gateway.guild-cloud.com
   *   - https://program-service.guildeducation.com
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   * #### Errors:
   *   - Validation errors if provided Academic Partner ID is not a UUID. _Does not currently validate that the AP ID is tied to an a real Academic Partner_
   *
   * #### Events:
   *   - Triggers `pser-program-created-event`
   *
   * #### Additional Notes:
   *   - Currently the UI for this is tied to the catalog admin UI, and this resolver is being called only through that means.
   */
  createGuildProgram: IGuildProgramResponse;
  createInstitution: IInstitutionResponse;
  createRemote?: Maybe<IRemoteRegistrationItem>;
  /** Create a Term */
  createTerm: ITerm;
  createUpdateBetaUser?: Maybe<IBetaUser>;
  cycUpsertMemberProgress?: Maybe<ICycMemberProgress>;
  /** Deletes an existing BillingPeriod based on the provided ID. */
  deleteAcademicPeriod: Scalars['Boolean']['output'];
  deleteBetaUser?: Maybe<IBetaUserIds>;
  /** Deletes an existing BillingPeriod based on the provided ID. */
  deleteBillingPeriod: Scalars['Boolean']['output'];
  deleteDataset?: Maybe<IDataset>;
  /** Deletes an existing EnrollmentPeriod based on the provided ID. */
  deleteEnrollmentPeriod: Scalars['Boolean']['output'];
  /** Delete Exchange Date Formula */
  deleteExchangeDateFormula: Scalars['Boolean']['output'];
  deleteFileVersion?: Maybe<IFileVersion>;
  deleteMemberUserAuth0?: Maybe<IMemberUserAuth0>;
  /**
   * This endpoint will find a single partner program record from the provided input and "soft-delete" it
   * by setting the version_end value of the record to its version_start value. It's actual version number
   * remains as-is.
   *
   * If a single record cannot be found it will throw an error, either that none were found, or too many
   * given the params provided as they are all optional. If an `id` is provided in the input, that is used and
   * all other params are ignored.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildSuperUser`, `superadmin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   * #### Errors
   * #### Events:
   * #### Additional Notes:
   */
  deletePartnerProgram: IDeletePartnerProgramResponse;
  deletePrice: IPriceMutationResponse;
  /** Delete a Term */
  deleteTerm: Scalars['Boolean']['output'];
  epol_createEmployerInfo?: Maybe<IEmployerInfo>;
  funding_bulkCreateCustomBenefitConfigurations?: Maybe<IFunding_BulkCreateCustomBenefitConfigurationResponse>;
  funding_bulkUpdateTaxPeriods: IFunding_BulkUpdateTaxPeriodsResponse;
  funding_createAdjustment?: Maybe<IFunding_Adjustment>;
  funding_createAdjustmentsFromFile: IFunding_BulkAdjustmentsResponse;
  funding_createCustomBenefitConfiguration?: Maybe<IFunding_CustomBenefitConfiguration>;
  funding_createSpend?: Maybe<ICreateSpendResponse>;
  funding_createTaxPeriod: IFunding_CreateTaxPeriodResponse;
  funding_generateLearnerSpendReport: IFunding_GenerateLearnerSpendReportResponse;
  funding_publishAsyncResponse?: Maybe<IAsyncResponse>;
  funding_updateCustomBenefitConfiguration?: Maybe<IFunding_CustomBenefitConfiguration>;
  funding_updateTaxEligible?: Maybe<IFunding_UpdateTaxEligibleResponse>;
  /**
   * This endpoint requires new partner program version input, including a code to which it will be associated. Therefore,
   * an ap_program_code record must already exist in order to use it in this endpoint, either linked or unlinked.
   *
   * This operation will:
   *   - Find the most recent existing partner program version for the partner program ID, guild program ID, and AP program code provided.
   *     - If no AP program code is found, it will error.
   *   - The new version is created, regardless of if the most recent version was found.
   *   - If the most recent version was found, it will be "ended" by setting its version_end to the incoming version_start
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildSuperUser`, `superadmin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   * #### Errors
   * #### Events:
   * #### Additional Notes:
   */
  newPartnerProgramVersion: INewPartnerProgramVersionResponse;
  newPrice: IPriceMutationResponse;
  /**
   * This endpoint receives a Base64 encoded string that is expected to be a CSV file input.
   * It will validate the input and either return an encoded string that contains errors with
   * validationErrors set to `true`, or `validationErrors` set to false and the results string
   * is an encoded approval list.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildSuperUser`, `guildAdmin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:guildSuperUser`, `PS:guildAdmin` ]
   *
   * ##### audiences (m2m)
   * [ `https://program-service.guildeducation.com`, `graphql-gateway.guild-cloud.com`, `https://frontend.guild-cloud.com` ]
   *
   * #### Example: TODO
   * #### Errors: TODO
   * #### Events:: TODO
   * #### Additional Notes:
   */
  prepareProgramMappings: IPrepareProgramMappingsResponse;
  /** Publish rollcall calendar */
  publishRollcallCalendar: Scalars['Boolean']['output'];
  /**
   * ### Release BillingPeriodCohort
   * Supports releasing a BillingPeriodCohort with or without an override.
   * If released with an override, the overrideExplanation is required.
   *
   * #### Authorization:
   *
   * ##### permissions
   * write:adminFinancials
   *
   * ##### scopes (m2m)
   * No scope authorization required
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://afs.guildeducation.com` ]
   */
  releaseBillingPeriodCohort: IBillingPeriodCohortStateUpdateResult;
  /**
   * Reassigns a ParterProgram from one Guild Program to another. This creates a new version of the PartnerProgram.
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   * #### Errors:
   *   - ResourceNotFound: `PartnerProgram` not found
   *   - ValidationError: startDate invalid date
   *   - ValidationError: startDate can not be in past
   * #### Events:
   *   - Triggers `pser-partner-program-relinked`
   * #### Additional Notes:
   *   - Relinking will end the prior version before creating a new one.
   *   - The ended version will be at the same time as the start of the new version
   *   - If `startDate` is ommitted, `now()` is used
   */
  relinkPartnerProgram: IPartnerProgram;
  /**
   * This mutation removes a PartnerProgram record by deactivating it. Only partnerPrograms that have not been active can be removed in this way.
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `https://graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example: TODO
   * #### Errors:
   *     - NotFoundError: `PartnerProgram` not found
   *     - ValidationError: AP Program Code has  version with startDate < now. We cannot remove a partnerProgram that has already been active.
   * #### Events:
   *     - _None_
   * #### Additional Notes:
   */
  removePartnerProgram: Scalars['Boolean']['output'];
  /**
   * Deletes an unlinked code.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Errors:
   *     - ValidationError: apProgramCode <apCode> not found
   *     - ValidationError: apProgramCode <apCode> is linked to a PartnerProgram
   *
   * #### Events:
   *   - None emitted
   *
   * #### Additional Notes:
   *   - Since there is no other data associated with unlinked codes, this is a true delete
   */
  removeUnlinkedCode: IApProgramCode;
  saveEmployerConfig?: Maybe<IPathwaysEmployerConfig>;
  saveRule?: Maybe<ISaveRuleResponse>;
  syncPathwaysContent?: Maybe<IResponse>;
  /** Updates an existing AcademicPeriod with the provided updates. */
  updateAcademicPeriod: IAcademicPeriod;
  updateAP: IAcademicPartnerResponse;
  /** Updates an existing BillingPeriod with the provided updates. */
  updateBillingPeriod: IBillingPeriod;
  /**
   * ### Update BillingPeriodCohort state excluding release
   * Currently only supports two use cases:
   * 1. allowing a Guild user to reject a partner's request for manual review (FAILED_QA on request)
   *   - current state must be REVIEW_REQUESTED, otherwise BillingPeriodCohortStateFailed response
   * 2. allowing a partner to request manual review (REVIEW_REQUESTED on request)
   *   - current state must be FAILED_QA, otherwise BillingPeriodCohortStateFailed response
   *
   * - all other states are accepted in the request, but will be receive a BillingPeriodCohortStateFailed response
   *
   * #### Authorization:
   *
   * ##### permissions
   * write:AP_financialsReconciliation', write:AP_financialsTuition
   *
   * ##### scopes (m2m)
   * No scope authorization required
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://afs.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   */
  updateBillingPeriodCohortStateExcludingRelease: IBillingPeriodCohortStateUpdateResult;
  updateDataset?: Maybe<IDataset>;
  updateEmployerPolicy?: Maybe<IEmployerPolicyResponse>;
  /** Updates an existing EnrollmentPeriod with the provided updates. */
  updateEnrollmentPeriod: IEnrollmentPeriod;
  /** Update a Exchange Date Formula for a given Academic Partner and Exchange Date Type */
  updateExchangeDateFormula: IExchangeDateFormula;
  updateFileVersion?: Maybe<IFileVersion>;
  /**
   * Updates a `GuildProgram` with the provided values.
   *
   * #### Authorization:
   *
   * _roles_:
   *   - guildAdmin
   *   - guildSuperUser
   *   - bat-admin
   *
   * _scopes (m2m)_:
   *   - PS:write:partner-program
   *
   * _audiences (m2m)_:
   *   - https://graphql-gateway.guild-cloud.com
   *   - https://program-service.guildeducation.com
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   * #### Errors:
   *
   *   - Validation errors if provided Academic Partner ID is not a UUID. _Does not currently validate that the AP ID is tied to an a real Academic Partner_
   *   - Validation errors if resulting Guild Program would not have all required fields set
   *
   * #### Events:
   *   - Triggers `pser-program-updated-event`
   *
   * #### Additional Notes:
   *   - Currently the UI for this is tied to the catalog admin UI, and this resolver is being called only through that means.
   */
  updateGuildProgram: IGuildProgramResponse;
  updateInstitution: IInstitutionResponse;
  updateMemberUserName?: Maybe<IMemberUser>;
  /**
   * Updates Dates for a `PartnerProgram` with the provided values.
   * **Note: Program service converts dates to midnight mountain of the provided time.
   * In the event no timezone offset is provided, the time is considered to be Mountain time.**
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `bat-admin` ]
   *
   * ##### scopes (m2m)
   * [ `PS:write:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `https://graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   * #### Errors:
   *
   * If startDate passed in is before now()
   *
   * ValidationError: Cannot modify this record's startDate - cannot change dates to a date prior to today. If this is something that needs to be done, contact support (AFO)
   *
   * If existing startDate is before now()/program has already started
   *
   * ValidationError: Cannot modify this record's startDate - this program has already started. If this is something that needs to be done, contact support (AFO)
   *
   * If there are multiple versions of the program, cannot just adjust the 1 date or will end up with gaps/overlaps
   *
   * ValidationError: Cannot modify this record's startDate - there cannot be an overlap or gap between dates with an existing prior version. If this is something that needs to be done, contact support (AFO)
   *
   * #### Events:
   *   - Triggers `pser-partner-program-updated`
   *
   * #### Additional Notes:
   *   - Clears caches
   *   - Since we are modifying a specific partnerProgramId, this has the getMany hardcoded to return test partners as well.
   */
  updatePartnerProgramDates: IPartnerProgram;
  updateProgramPricesBillingUnit: IPriceListMutationResponse;
  updateSFTP?: Maybe<ISftp>;
  /** Update a Term */
  updateTerm: ITerm;
  uploadSampleFile?: Maybe<ISampleFile>;
  upsertEpPortalUserBatch?: Maybe<Array<Maybe<IEpPortalUser>>>;
  /** Upsert (create or update) a Exchange Date Formula for a given Academic Partner and Exchange Date Type */
  upsertExchangeDateFormulas: Scalars['Boolean']['output'];
  upsertMemberUserAuth0?: Maybe<IMemberUserAuth0>;
  /** Upsert (create or update) BillingPeriods and/or EnrollmentPeriods with the provided updates. */
  upsertRollcallBillingAndEnrollmentPeriods: IRollcallBillingAndEnrollmentPeriodsResponse;
  /**
   * Upsert data on first step of the Rollcall Calendar form. Note, when id is
   * missing, a create will be performed, when present the data will be updated
   * on each entity (Calendar or EnrollmentPeriod)
   */
  upsertRollcallCalendarAndAcademicPeriods?: Maybe<IRollcallCalendarAndAcademicPeriodsResponse>;
  /** Upsert (create or update) Exchange Dates for a provided academic period. */
  upsertRollcallDataExchangeDates: IRollcallDataExchangeDatesResponse;
  /**
   * Upsert formulas for a specified academic partner and calendar
   * Intended to match shape from Rollcall Calendar's form
   */
  upsertRollcallDataExchangeFormulas?: Maybe<IUpsertRollcallDataExchangeFormulasResponse>;
  /** Bulk upsert (create or update) many terms for a given Academic Partner */
  upsertTerms: IUpsertTermsResponse;
  writePathwaysForEmployer: Array<Maybe<IPathwayForEmployerConfig>>;
};

export type IMutationAddLinkedCodeArgs = {
  academicPartnerId: Scalars['ID']['input'];
  apProgramCode: Scalars['String']['input'];
  guildProgramId: Scalars['ID']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationAddUnlinkedCodeArgs = {
  academicPartnerId: Scalars['String']['input'];
  apProgramCode: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IMutationAliasCodeArgs = {
  apProgramCode: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  partnerProgramId: Scalars['ID']['input'];
  setPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IMutationAnonymizeMemberUserArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationApproveEmployerPolicyArgs = {
  policyId: Scalars['ID']['input'];
  requestedBy: Scalars['String']['input'];
};

export type IMutationApproveRollcallAcademicPeriodArgs = {
  academicPartnerId: Scalars['ID']['input'];
  academicPeriodId: Scalars['ID']['input'];
  approvals: IAcademicPeriodApprovals;
};

export type IMutationArchiveEmployerPolicyArgs = {
  policyId: Scalars['ID']['input'];
};

export type IMutationAssociateSampleFileArgs = {
  datasetName: Scalars['String']['input'];
  employerUUID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileVersion: Scalars['Int']['input'];
};

export type IMutationBatchPartnerProgramProcessingArgs = {
  academicPartnerId: Scalars['ID']['input'];
  batchRequestId: Scalars['ID']['input'];
  codeRequests: Array<IBatchPartnerProgramProcessingInput>;
};

export type IMutationBulkInsertBillingPeriodsArgs = {
  bulkInsertInput: IBulkInsertInput;
};

export type IMutationChangePriceArgs = {
  billingUnit: IBillingUnit;
  costPerUnit: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  priceTypeUuid: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationCommitProgramMappingsArgs = {
  inputMappingData: Scalars['String']['input'];
};

export type IMutationCreateAcademicCalendarArgs = {
  calendar: IAcademicCalendarInput;
};

export type IMutationCreateAcademicPeriodArgs = {
  academicPeriod: ICreateAcademicPeriodInput;
};

export type IMutationCreateApArgs = {
  academicPartner: IAcademicPartnerCreateInput;
};

export type IMutationCreateBillingPeriodArgs = {
  billingPeriod: ICreateBillingPeriodInput;
};

export type IMutationCreateDatasetArgs = {
  active: Scalars['Boolean']['input'];
  employerUUID: Scalars['ID']['input'];
  filePattern?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<IDatasetStatus>;
  type?: InputMaybe<IDatasetType>;
};

export type IMutationCreateEmployerPolicyArgs = {
  input: IEmployerPolicyCreateInput;
};

export type IMutationCreateEncryptionKeysArgs = {
  algorithm?: InputMaybe<IEncryptionAlgorithm>;
  employerShortName: Scalars['String']['input'];
  employerUUID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  passphrase?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationCreateEnrollmentPeriodArgs = {
  enrollmentPeriod: ICreateEnrollmentPeriodInput;
};

export type IMutationCreateExchangeDateFormulaArgs = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  exchangeDateTypeId: Scalars['ID']['input'];
  offsetFormula: Scalars['String']['input'];
};

export type IMutationCreateFileVersionArgs = {
  active: Scalars['Boolean']['input'];
  datasetName: Scalars['String']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
  employerUUID: Scalars['ID']['input'];
  encrypted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  headers?: InputMaybe<Scalars['AWSJSON']['input']>;
  name?: InputMaybe<Scalars['Int']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<IDatasetStatus>;
};

export type IMutationCreateGuildProgramArgs = {
  academicPartnerId: Scalars['String']['input'];
  program: IGuildProgramCreateInput;
};

export type IMutationCreateInstitutionArgs = {
  institution: IInstitutionCreateInput;
  paymentNetwork: IInstitutionPaymentNetworkFeatureCreateInput;
};

export type IMutationCreateRemoteArgs = {
  appId: Scalars['String']['input'];
  availableInProduction: Scalars['Boolean']['input'];
  descriptiveName: Scalars['String']['input'];
  includeInNavigation: Scalars['Boolean']['input'];
  includeInSitemap: Scalars['Boolean']['input'];
  module: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  remoteUrl?: InputMaybe<Scalars['String']['input']>;
  repoName: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  sideNavModuleName?: InputMaybe<Scalars['String']['input']>;
  siteMapSubpathLinks?: InputMaybe<Array<InputMaybe<ISubmapLinkInput>>>;
};

export type IMutationCreateTermArgs = {
  term: ITermCreateInput;
};

export type IMutationCreateUpdateBetaUserArgs = {
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IMutationCycUpsertMemberProgressArgs = {
  feedback?: InputMaybe<ICycMemberProgressFeedback>;
  memberUuid: Scalars['String']['input'];
  status?: InputMaybe<ICycMemberProgressStatus>;
  webinyEntryId: Scalars['String']['input'];
};

export type IMutationDeleteAcademicPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationDeleteBetaUserArgs = {
  employeeId: Scalars['String']['input'];
  employerId: Scalars['String']['input'];
};

export type IMutationDeleteBillingPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationDeleteDatasetArgs = {
  employerUUID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type IMutationDeleteEnrollmentPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationDeleteExchangeDateFormulaArgs = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  exchangeDateTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type IMutationDeleteFileVersionArgs = {
  datasetName: Scalars['String']['input'];
  employerUUID: Scalars['ID']['input'];
  name: Scalars['Int']['input'];
};

export type IMutationDeleteMemberUserAuth0Args = {
  deleteMemberUserAuth0Input?: InputMaybe<IDeleteMemberUserAuth0Input>;
};

export type IMutationDeletePartnerProgramArgs = {
  input: IDeletePartnerProgramInput;
};

export type IMutationDeletePriceArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationDeleteTermArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationEpol_CreateEmployerInfoArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['String']['input'];
  employerResources?: InputMaybe<Array<InputMaybe<IEmployerResourcesInput>>>;
  platformReadyDate?: InputMaybe<Scalars['AWSDate']['input']>;
  termPlural?: InputMaybe<Scalars['String']['input']>;
  termSingular?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationFunding_BulkCreateCustomBenefitConfigurationsArgs = {
  input?: InputMaybe<IFunding_BulkCreateCustomBenefitConfigurationInput>;
};

export type IMutationFunding_BulkUpdateTaxPeriodsArgs = {
  input?: InputMaybe<IFunding_BulkUpdateTaxPeriodsInput>;
};

export type IMutationFunding_CreateAdjustmentArgs = {
  input?: InputMaybe<IFunding_CreateAdjustmentInput>;
};

export type IMutationFunding_CreateAdjustmentsFromFileArgs = {
  input?: InputMaybe<IFunding_CreateAdjustmentsFromFileInput>;
};

export type IMutationFunding_CreateCustomBenefitConfigurationArgs = {
  input?: InputMaybe<IFunding_CreateCustomBenefitConfigurationInput>;
};

export type IMutationFunding_CreateSpendArgs = {
  input?: InputMaybe<IFunding_CreateSpend>;
};

export type IMutationFunding_CreateTaxPeriodArgs = {
  input?: InputMaybe<IFunding_CreateTaxPeriodInput>;
};

export type IMutationFunding_GenerateLearnerSpendReportArgs = {
  input?: InputMaybe<IFunding_GenerateLearnerSpendReport>;
};

export type IMutationFunding_PublishAsyncResponseArgs = {
  asyncRequestId: Scalars['ID']['input'];
  channelName: Scalars['String']['input'];
  data: Scalars['AWSJSON']['input'];
};

export type IMutationFunding_UpdateCustomBenefitConfigurationArgs = {
  input?: InputMaybe<IFunding_UpdateCustomBenefitConfiguration>;
};

export type IMutationFunding_UpdateTaxEligibleArgs = {
  input?: InputMaybe<IFunding_UpdateTaxEligible>;
};

export type IMutationNewPartnerProgramVersionArgs = {
  input: INewPartnerProgramVersionInput;
};

export type IMutationNewPriceArgs = {
  academicPartnerUuid: Scalars['ID']['input'];
  billingUnit: IBillingUnit;
  costPerUnit: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  priceTypeUuid: Scalars['ID']['input'];
  programUuid: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationPrepareProgramMappingsArgs = {
  inputMappingData: Scalars['String']['input'];
};

export type IMutationPublishRollcallCalendarArgs = {
  input: IPublishRollcallCalendarInput;
};

export type IMutationReleaseBillingPeriodCohortArgs = {
  input: IReleaseBillingPeriodCohortRequest;
};

export type IMutationRelinkPartnerProgramArgs = {
  guildProgramId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationRemovePartnerProgramArgs = {
  id: Scalars['ID']['input'];
};

export type IMutationRemoveUnlinkedCodeArgs = {
  academicPartnerId: Scalars['String']['input'];
  apProgramCode: Scalars['String']['input'];
  includeTestData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IMutationSaveEmployerConfigArgs = {
  saveEmployerConfigInput: ISaveEmployerConfigInput;
};

export type IMutationSaveRuleArgs = {
  active: Scalars['Boolean']['input'];
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  coveragePackageId?: InputMaybe<Scalars['ID']['input']>;
  criteria: Scalars['AWSJSON']['input'];
  descriptions?: InputMaybe<Scalars['AWSJSON']['input']>;
  eligibilityType: IEligibilityType;
  employerId: Scalars['ID']['input'];
  guildApprovalDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  guildApprover?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  partnerApprovalDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  partnerApprover?: InputMaybe<Scalars['String']['input']>;
  reasonDetail?: InputMaybe<Scalars['String']['input']>;
  ruleLevel: IRuleLevel;
  ruleName?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<Scalars['AWSJSON']['input']>;
  updateRule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IMutationUpdateAcademicPeriodArgs = {
  id: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updates: IUpdateAcademicPeriodInput;
};

export type IMutationUpdateApArgs = {
  academicPartner: IAcademicPartnerUpdateInput;
};

export type IMutationUpdateBillingPeriodArgs = {
  id: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updates: IUpdateBillingPeriodInput;
};

export type IMutationUpdateBillingPeriodCohortStateExcludingReleaseArgs = {
  input: IUpdateBillingPeriodCohortStateExcludingReleaseRequest;
};

export type IMutationUpdateDatasetArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  employerUUID: Scalars['ID']['input'];
  filePattern?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<IDatasetStatus>;
  type?: InputMaybe<IDatasetType>;
};

export type IMutationUpdateEmployerPolicyArgs = {
  input: IEmployerPolicyUpdateInput;
};

export type IMutationUpdateEnrollmentPeriodArgs = {
  id: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updates: IUpdateEnrollmentPeriodInput;
};

export type IMutationUpdateExchangeDateFormulaArgs = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  exchangeDateTypeId: Scalars['ID']['input'];
  offsetFormula: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationUpdateFileVersionArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  datasetName: Scalars['String']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
  employerUUID: Scalars['ID']['input'];
  encrypted?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  headers?: InputMaybe<Scalars['AWSJSON']['input']>;
  name: Scalars['Int']['input'];
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<IDatasetStatus>;
};

export type IMutationUpdateGuildProgramArgs = {
  academicPartnerId: Scalars['String']['input'];
  program: IGuildProgramUpdateInput;
};

export type IMutationUpdateInstitutionArgs = {
  institution: IInstitutionUpdateInput;
  paymentNetwork: IInstitutionPaymentNetworkFeatureCreateInput;
};

export type IMutationUpdateMemberUserNameArgs = {
  updateMemberUserNameInput?: InputMaybe<IUpdateMemberUserNameInput>;
};

export type IMutationUpdatePartnerProgramDatesArgs = {
  id: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};

export type IMutationUpdateProgramPricesBillingUnitArgs = {
  academicPartnerUuid: Scalars['ID']['input'];
  billingUnit: IBillingUnit;
  programUuid: Scalars['ID']['input'];
};

export type IMutationUpdateSftpArgs = {
  employerUUID: Scalars['ID']['input'];
  parentFolderName: Scalars['String']['input'];
};

export type IMutationUpdateTermArgs = {
  id: Scalars['ID']['input'];
  term: ITermUpdateInput;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationUploadSampleFileArgs = {
  employerUUID: Scalars['ID']['input'];
  encrypted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type IMutationUpsertEpPortalUserBatchArgs = {
  upsertEpPortalUserBatchInput?: InputMaybe<Array<InputMaybe<IUpsertEpPortalUserInput>>>;
};

export type IMutationUpsertExchangeDateFormulasArgs = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  exchangeDateFormula: Array<IUpsertExchangeDateFormulasInput>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationUpsertMemberUserAuth0Args = {
  upsertMemberUserAuth0Input?: InputMaybe<IUpsertMemberUserAuth0Input>;
};

export type IMutationUpsertRollcallBillingAndEnrollmentPeriodsArgs = {
  academicPartnerId: Scalars['ID']['input'];
  academicPeriodId: Scalars['ID']['input'];
  billingPeriods: Array<IUpsertRollcallBillingAndEnrollmentPeriodsInput>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationUpsertRollcallCalendarAndAcademicPeriodsArgs = {
  formInput: IRollcallCalendarAndAcademicPeriodsInput;
};

export type IMutationUpsertRollcallDataExchangeDatesArgs = {
  billingPeriods: Array<IUpsertRollcallDataExchangeDatesInput>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IMutationUpsertRollcallDataExchangeFormulasArgs = {
  input?: InputMaybe<IUpsertRollcallDataExchangeFormulasInput>;
};

export type IMutationUpsertTermsArgs = {
  academicPartnerId: Scalars['ID']['input'];
  batchCorrelationId?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  records: Array<ITermUpsertInputWrapper>;
};

export type IMutationWritePathwaysForEmployerArgs = {
  writePathwaysForEmployerInput: Array<InputMaybe<IWritePathwaysForEmployerInput>>;
};

/** A parent field of study used within Children to prevent recursion. */
export type INestedParentFieldOfStudy = {
  /** stable unique identifier for the field of study */
  id: Scalars['ID']['output'];
  /** Human readable name of the field of study */
  name: Scalars['String']['output'];
};

export type INewPartnerProgramVersionInput = {
  academicPartnerId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  guildProgramId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  versionEnd?: InputMaybe<Scalars['String']['input']>;
  versionStart: Scalars['String']['input'];
};

export type INewPartnerProgramVersionResponse = {
  created?: Maybe<IPartnerProgram>;
  errors: Array<Maybe<IAfoResponseError>>;
  success: Scalars['Boolean']['output'];
};

export enum INonStandardProductName {
  CANDIDLY = 'CANDIDLY',
  PROFESSIONAL_EXPENSES = 'PROFESSIONAL_EXPENSES',
}

export type INontuition_Expense = {
  amountRemainingCents?: Maybe<Scalars['Int']['output']>;
  amountSpentCents: Scalars['Int']['output'];
  fundingLimitCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  includedInTuition: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type IOption = {
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type IOrderByInputCourseEnrollment = {
  /** Name of Course Enrollment field */
  name: ISortFieldCourseEnrollment;
  /** Sort order (ASC or DESC) */
  sort?: InputMaybe<ISortOrder>;
};

export type IOrderByInputProgramEnrollment = {
  /** Name of Program Enrollment field */
  name: ISortFieldProgramEnrollment;
  /** Sort order (ASC or DESC) */
  sort?: InputMaybe<ISortOrder>;
};

export type IOverride = {
  effectiveEndDate: Scalars['AWSDateTime']['output'];
  effectiveStartDate: Scalars['AWSDateTime']['output'];
  originalOutcome: Scalars['Boolean']['output'];
  overrideOutcome: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

export type IPaginatedCourseEnrollments = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of Enrollments */
  enrollments: Array<ICourseEnrollment>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total Count of all results */
  total?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type IPaginatedEnrollmentDataIngestErrors = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of data ingest errors */
  dataIngestErrors: Array<IEnrollmentDataIngestError>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total count of all results */
  total?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type IPaginatedProgramEnrollments = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of Enrollments */
  enrollments: Array<IProgramEnrollment>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total Count of all results */
  total?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type IPaginationInput = {
  /** Max number of items per page */
  count: Scalars['Int']['input'];
  /** Current page number */
  page: Scalars['Int']['input'];
};

/** A top-level field of study. */
export type IParentFieldOfStudy = {
  /** Whether or not the parent field of study is activated or legacy. A signal to consumers of deprecation. */
  active: Scalars['Boolean']['output'];
  /** List of related ChildFieldsOfStudy */
  children: Array<IChildFieldOfStudy>;
  /** stable unique identifier for the field of study */
  id: Scalars['ID']['output'];
  /** Human readable name of the field of study */
  name: Scalars['String']['output'];
};

export type IPartnerProgram = {
  /** this will be populated via APS + global gateway */
  academicPartner: IAcademicPartner;
  /** a list of ApProgram Codes - only one primary code at any given time */
  apProgramCodes: Array<IApProgramCode>;
  /** timestamp when the record was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** userId that created this Program */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The related Program record, when unmapped, this is null  - populated via nested querying (calls Query:guildProgram with specific criteria) */
  guildProgram?: Maybe<IGuildProgram>;
  /** Used in service appsync instance to drive internal nested Queries. Users should access the guildProgram value for this information */
  guildProgramId?: Maybe<Scalars['ID']['output']>;
  /** unique identifier for the returned partner program. */
  id: Scalars['ID']['output'];
  /** true when only used for internal testing */
  isTest: Scalars['Boolean']['output'];
  /** timestamp when the record was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** userId that last updated this Program */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * The date range that represents the validity of this set of values - used for asOf querying.
   * **NOTE: Datetimes are converted to be midnight mountain time of the passed date.**
   * *For example: 01/02/2023 04:05:06Z will be converted to 01/02/2023 00:00:00-07:00*
   */
  versionDates: IPsDateRange;
};

/**
 * Filtering criteria when listing `PartnerPrograms`.
 * Each provided filter further narrows the results (ie: using **AND** not OR)
 */
export type IPartnerProgramListInput = {
  /** UUID of the associated `AcademicPartner` */
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  /** String in ISO DateTime format. If omitted, current time is used */
  asOf?: InputMaybe<Scalars['String']['input']>;
  /** Tests values are omitted by default, this flag includes them. */
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IPartnerProgramListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of Programs */
  data?: Maybe<Array<IPartnerProgram>>;
  /** List of errors */
  errors: Array<IProgramErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** ex: 200 */
  statusCode: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export enum IPartnerProgramProcessingOutcome {
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  FOUND = 'FOUND',
}

export type IPartnerProgramProcessingResponse = {
  apProgramCode?: Maybe<IApProgramCode>;
  outcome: IPartnerProgramProcessingOutcome;
  requestId: Scalars['ID']['output'];
};

export type IPathway = {
  content: IPathwayContent;
  pathwayEnabled: Scalars['Boolean']['output'];
  pathwayId: Scalars['ID']['output'];
  pathwayName: Scalars['String']['output'];
  programUuids: Array<Maybe<Scalars['String']['output']>>;
};

export type IPathwayCareerPath = {
  body?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

export type IPathwayConfig = {
  pathwayEnabled: Scalars['Boolean']['output'];
  pathwayId: Scalars['ID']['output'];
  pathwayName: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<IPathwayConfigRole>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type IPathwayConfigRole = {
  baseEntryId?: Maybe<Scalars['String']['output']>;
  commonTitles?: Maybe<Scalars['String']['output']>;
  customCommonTitles?: Maybe<Scalars['String']['output']>;
  customEducation?: Maybe<Scalars['String']['output']>;
  entryId?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwayContent = {
  careerPath?: Maybe<IPathwayCareerPath>;
  createdOn?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duties?: Maybe<IPathwayDuties>;
  faq?: Maybe<Array<IPathwayFaq>>;
  heroImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<IPathwayQuote>;
  roles?: Maybe<Array<IPathwayRole>>;
  savedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<IPathwaySkill>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  video?: Maybe<IPathwayVideo>;
};

export type IPathwayCustomRoleInput = {
  baseEntryId: Scalars['ID']['input'];
  customCommonTitles?: InputMaybe<Scalars['String']['input']>;
  customEducation?: InputMaybe<Scalars['String']['input']>;
  entryId?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IPathwayDuties = {
  body?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<IPathwayItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwayFaq = {
  body?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwayForEmployerConfig = {
  employerId: Scalars['String']['output'];
  pathwayEnabled: Scalars['Boolean']['output'];
  pathwayId: Scalars['ID']['output'];
  roles?: Maybe<Array<Maybe<IPathwayConfigRole>>>;
};

export type IPathwayItem = {
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwayQuote = {
  body?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type IPathwayRole = {
  body?: Maybe<Scalars['String']['output']>;
  commonTitles?: Maybe<Scalars['String']['output']>;
  customCommonTitles?: Maybe<Scalars['String']['output']>;
  customEducation?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Array<IPathwayItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwaysEmployerConfig = {
  employerId: Scalars['String']['output'];
  pathwaysEnabled: Scalars['Boolean']['output'];
};

export type IPathwaySkill = {
  body?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<IPathwaySkillItem>>;
};

export type IPathwaySkillItem = {
  body?: Maybe<Scalars['String']['output']>;
  pictogram?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IPathwayVideo = {
  body?: Maybe<Scalars['String']['output']>;
  videoScriptPdf?: Maybe<Scalars['String']['output']>;
  videoScriptUrl?: Maybe<Scalars['String']['output']>;
  videoThumbnailImage?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export enum IPaymentModality {
  DEFERRED_TUITION = 'DEFERRED_TUITION',
  DIRECT_PAYMENT_PROGRAM = 'DIRECT_PAYMENT_PROGRAM',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT',
}

export type IPaymentModalitySupport = {
  effectiveDate: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  type: IPaymentModalityType;
};

export enum IPaymentModalityType {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement',
}

export enum IPaymentNetworkAvailability {
  DEFERRED_TUITION = 'DEFERRED_TUITION',
  DIRECT_PAYMENT_PROGRAM = 'DIRECT_PAYMENT_PROGRAM',
  INELIGIBLE = 'INELIGIBLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT',
}

export type IPaymentNetworkAvailabilityDecision = {
  availability: IPaymentNetworkAvailability;
};

export type IPeriodEnrollment = {
  enrollmentPeriodId: Scalars['ID']['output'];
  enrollmentVerified?: Maybe<Scalars['Boolean']['output']>;
  periodEnrollmentId: Scalars['ID']['output'];
};

export enum IPeriodTypeEnum {
  ACADEMICPERIOD = 'academicPeriod',
  TERM = 'term',
}

export type IPictogram = {
  pictogramImageName?: Maybe<Scalars['String']['output']>;
};

export enum IPortalModuleAccessEnum {
  ADMIN = 'admin',
  ADMISSIONS = 'admissions',
  COURSES = 'courses',
  ELIGIBILITY = 'eligibility',
  FILES = 'files',
  FINANCIALS = 'financials',
  HOME = 'home',
  SPONSORSHIP = 'sponsorship',
  STUDENTS = 'students',
}

export type IPrepareProgramMappingsResponse = {
  isValidationErrors: Scalars['Boolean']['output'];
  results: Scalars['String']['output'];
  transactionError?: Maybe<IAfoResponseError>;
};

export type IPrice = {
  academicPartnerUuid: Scalars['ID']['output'];
  billingUnit: IBillingUnit;
  costPerUnit: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  priceType: IPriceType;
  programUuid: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export enum IPriceFilter {
  ACTIVE = 'Active',
  VALID = 'Valid',
}

export type IPriceListMutationResponse = {
  /** Data contains the response value */
  data: Array<Maybe<IPrice>>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IFederatedErrorResponse>;
};

export type IPriceMutationResponse = {
  /** Data contains the response value */
  data?: Maybe<IPrice>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IFederatedErrorResponse>;
};

export type IPriceType = {
  employerUuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum IPrimaryPaymentModalityEnum {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement',
}

export type IProduct = {
  attributes?: Maybe<IAttributes>;
  available: Scalars['Boolean']['output'];
  covered_expenses?: Maybe<Array<Maybe<ICoveredExpense>>>;
  enabled_types?: Maybe<Array<Maybe<IEnabledType>>>;
  funding_packages?: Maybe<Array<IFundingPackage>>;
  name: Scalars['String']['output'];
};

export type IProductContext = {
  sponsorship?: InputMaybe<ISponsorshipProductContext>;
  tuitionAssistance?: InputMaybe<ITuitionAssistanceProductContext>;
  tuitionReimbursement?: InputMaybe<ITuitionReimbursementProductContext>;
};

export enum IProductStatusTag {
  ELIGIBLE = 'ELIGIBLE',
  ELIGIBLE_SOON = 'ELIGIBLE_SOON',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export type IProgram = {
  internalPartnerProgramId: Scalars['String']['output'];
};

export type IProgramEnrollment = {
  academicPartner: IAcademicPartner;
  correlationId?: Maybe<Scalars['ID']['output']>;
  courseEnrollments?: Maybe<Array<ICourseEnrollment>>;
  creditsEarned?: Maybe<Scalars['Float']['output']>;
  cumulativeGpa?: Maybe<Scalars['Float']['output']>;
  effectiveStart: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  externalEnrollmentStatus?: Maybe<Scalars['String']['output']>;
  externalProgramCode?: Maybe<Scalars['String']['output']>;
  externalStudentIdentifier?: Maybe<Scalars['String']['output']>;
  guildUuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  internalStudentId?: Maybe<Scalars['String']['output']>;
  periodEnrollments?: Maybe<Array<Maybe<IPeriodEnrollment>>>;
  program: IProgram;
  recordedAt: Scalars['String']['output'];
  recordedBy: Scalars['String']['output'];
  startDate: Scalars['AWSDate']['output'];
  status: IEnrollmentStatus;
  transferCredits?: Maybe<Scalars['Float']['output']>;
};

export type IProgramEnrollmentListResponse = IAesResponse & {
  /** Data contains the paginated response value */
  data?: Maybe<IPaginatedProgramEnrollments>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Standard HTTP Status Code */
  statusCode: Scalars['Int']['output'];
};

export type IProgramEnrollmentsByBillingPeriodInput = {
  options: IProgramEnrollmentsByBillingPeriodOptions;
  orderBy?: InputMaybe<Array<IOrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<IPaginationInput>;
};

export type IProgramEnrollmentsByBillingPeriodOptions = {
  billingPeriodId: Scalars['String']['input'];
};

export type IProgramEnrollmentsByGuildUuidInput = {
  options: IProgramEnrollmentsByGuildUuidOptions;
  orderBy?: InputMaybe<Array<IOrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<IPaginationInput>;
};

export type IProgramEnrollmentsByGuildUuidOptions = {
  /** Optional to support requesting program enrollments for a specific LP */
  academicPartnerId?: InputMaybe<Scalars['String']['input']>;
  effectiveStart?: InputMaybe<Scalars['String']['input']>;
  guildUuid: Scalars['String']['input'];
};

export type IProgramEnrollmentsByGuildUuidsInput = {
  options: IProgramEnrollmentsByGuildUuidsOptions;
  orderBy?: InputMaybe<Array<IOrderByInputProgramEnrollment>>;
  pagination?: InputMaybe<IPaginationInput>;
};

export type IProgramEnrollmentsByGuildUuidsOptions = {
  /** Optional to support requesting program enrollments for a specific LP */
  academicPartnerId?: InputMaybe<Scalars['String']['input']>;
  effectiveStart?: InputMaybe<Scalars['String']['input']>;
  guildUuids: Array<Scalars['String']['input']>;
};

/** Error details coming from a mutation in program service */
export type IProgramErrorResponse = {
  /** Error message string which typically provides finer detail to the specific error */
  errorMessage: Scalars['String']['output'];
  /** Error Types related to service level errors and may be things like NotFound or ValidationError, but may also be other system errors */
  errorType: Scalars['String']['output'];
  /** An idempotent ID for the request */
  requestId?: Maybe<Scalars['String']['output']>;
};

export enum IProgramKind {
  ADVANCED_CERTIFICATE = 'ADVANCED_CERTIFICATE',
  ASSOCIATE_OF_ARTS_DEGREE = 'ASSOCIATE_OF_ARTS_DEGREE',
  ASSOCIATE_OF_SCIENCE_DEGREE = 'ASSOCIATE_OF_SCIENCE_DEGREE',
  BACHELOR_OF_APPLIED_SCIENCE = 'BACHELOR_OF_APPLIED_SCIENCE',
  BACHELOR_OF_ARTS_DEGREE = 'BACHELOR_OF_ARTS_DEGREE',
  BACHELOR_OF_BUSINESS_ADMINISTRATION = 'BACHELOR_OF_BUSINESS_ADMINISTRATION',
  BACHELOR_OF_GENERAL_STUDIES = 'BACHELOR_OF_GENERAL_STUDIES',
  BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE = 'BACHELOR_OF_PROFESSIONAL_SERVICE_DEGREE',
  BACHELOR_OF_SCIENCE_DEGREE = 'BACHELOR_OF_SCIENCE_DEGREE',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTOR_OF_NURSING_PRACTICE = 'DOCTOR_OF_NURSING_PRACTICE',
  DOCTOR_OF_PHYSICAL_THERAPY = 'DOCTOR_OF_PHYSICAL_THERAPY',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  INTERMEDIATE_CERTIFICATE = 'INTERMEDIATE_CERTIFICATE',
  INTRODUCTORY_CERTIFICATE = 'INTRODUCTORY_CERTIFICATE',
  LANGUAGE = 'LANGUAGE',
  MASTER_OF_ARTS_DEGREE = 'MASTER_OF_ARTS_DEGREE',
  MASTER_OF_BUSINESS_ADMINISTRATION = 'MASTER_OF_BUSINESS_ADMINISTRATION',
  MASTER_OF_HEALTHCARE_ADMINISTRATION = 'MASTER_OF_HEALTHCARE_ADMINISTRATION',
  MASTER_OF_PUBLIC_ADMINISTRATION = 'MASTER_OF_PUBLIC_ADMINISTRATION',
  MASTER_OF_SCIENCE_DEGREE = 'MASTER_OF_SCIENCE_DEGREE',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT',
}

export type IProgramResult = IBaseResult & {
  academicPartnerId?: Maybe<Scalars['ID']['output']>;
  criteria?: Maybe<Array<Maybe<ICriteria>>>;
  eligible: Scalars['Boolean']['output'];
  override?: Maybe<IOverride>;
  programId?: Maybe<Scalars['ID']['output']>;
};

export type IProgramType = {
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  programKind?: Maybe<IProgramKind>;
  shortProgramKind?: Maybe<IShortProgramKind>;
  studentFacingAcademicPartner?: Maybe<IAcademicPartnerType>;
  uuid: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

/** Date range representation used by the Program Service */
export type IPsDateRange = {
  /** String in ISO DateTime format. If empty or null, treat as an "open" range */
  end?: Maybe<Scalars['String']['output']>;
  /** String in ISO DateTime format. */
  start: Scalars['String']['output'];
};

/** Basic sorting input criteria for Program Service */
export type IPsOrderBySortInput = {
  /** Field name to sort by */
  name: Scalars['String']['input'];
  /** Direction of the sort (ascending or descending) */
  sort: IPsOrderDirection;
};

/** OrderBy input to determine ordering direction */
export enum IPsOrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}

/** Basic Pagination input criteria for Program Service */
export type IPsPaginationInput = {
  /** Total amount of items returned in your response if available. Default = 50 */
  count: Scalars['Int']['input'];
  /** The page you would like to select based on the coun */
  page: Scalars['Int']['input'];
};

export type IPublicKey = {
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IPublishRollcallCalendarInput = {
  /** UUID for Academic Partner */
  academicPartnerId: Scalars['ID']['input'];
  /** UUID for Calendar */
  calendarId: Scalars['ID']['input'];
  /** Boolean for if calendar should be published */
  published: Scalars['Boolean']['input'];
  /** (optional) Updated by identifier, will be pulled from token if not provided */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IQuery = {
  /** Retrieves an AcademicCalendar by ID */
  academicCalendar?: Maybe<IAcademicCalendar>;
  /** Retrieves many AcademicCalendars by AP ID */
  academicCalendars: IAcademicCalendarListResponse;
  /** Server status/hello world */
  academicCalendarServiceStatus: IServerStatusResponse;
  academicPartner?: Maybe<IAcademicPartner>;
  academicPartnerByShortname?: Maybe<IAcademicPartner>;
  academicPartners: IAcademicPartnerListResponse;
  /** Retrieves a AcademicPeriod by its ID. */
  academicPeriod?: Maybe<IAcademicPeriod>;
  /** Retrieves a list of AcademicPeriods based on calendarId. */
  academicPeriods: IAcademicPeriodListResponse;
  /**
   * Retrieves an AchievementType from UUID
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read`, `member` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:achievementTypes` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   * ```
   * query AchievementType($id: ID!) {
   *   achievementType(id: $id) {
   *     id
   *     name
   *   }
   * }
   * ```
   *
   * #### Additional Notes:
   * - Filters by `achievement_type.id`
   */
  achievementType: IAchievementType;
  /**
   * Retrieves a list of AchievementTypes
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read`, `member` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:achievementTypes` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   *   - no filtering currently available
   */
  achievementTypes: Array<IAchievementType>;
  anyUserType: Array<Maybe<IAnyUser>>;
  application?: Maybe<IApplication>;
  /** Retrieves a list of Terms by ID. Used by the gateway to mitigate the n+1 problem. */
  batchTermByIds: Array<Maybe<ITerm>>;
  benefitOverviewSimplified?: Maybe<IBenefitOverviewSimplified>;
  benefitOverviewSummary?: Maybe<IBenefitOverviewSummary>;
  /** Retrieves a BillingPeriod by its ID. */
  billingPeriod?: Maybe<IBillingPeriod>;
  /** Retrieves a BillingPeriod by its unique code and associated academicPartnerId. */
  billingPeriodByCode?: Maybe<IBillingPeriod>;
  /** Retrieves a list of BillingPeriods based on provided criteria and optional pagination. */
  billingPeriods: IBillingPeriodListResponse;
  bookmarks?: Maybe<Array<Maybe<IBookmarkType>>>;
  catalogMemberPrograms?: Maybe<Array<Maybe<IProgramType>>>;
  catalogProgram?: Maybe<IProgramType>;
  catalogPrograms?: Maybe<Array<Maybe<IProgramType>>>;
  catalogProgramUuid?: Maybe<IProgramType>;
  /** Get list of Course Enrollments by BillingPeriods */
  courseEnrollmentsByBillingPeriod: ICourseEnrollmentListResponse;
  /** Get list of Course Enrollments by GuildUuids */
  courseEnrollmentsByGuildUuid: ICourseEnrollmentListResponse;
  coverageSummaries?: Maybe<ICoverageSummaries>;
  cycGetEmployerConfig?: Maybe<IEmployerConfig>;
  cycListDashboards?: Maybe<Array<Maybe<IDashboard>>>;
  cycListMemberProgress?: Maybe<Array<Maybe<ICycMemberProgress>>>;
  decryptAndDownloadFile?: Maybe<ISampleFile>;
  eligibilityAndCoverageSummaries?: Maybe<IEligibilityAndCoverageSummaries>;
  eligibilitySummary?: Maybe<IEligibilitySummary>;
  /** Get list of employer identies by userId */
  employerIdentities: Array<IIdentity>;
  /** Retrieves an EnrollmentPeriod by its ID. */
  enrollmentPeriod?: Maybe<IEnrollmentPeriod>;
  /** Retrieves a EnrollmentPeriod by its unique code and associated academicPartnerId. */
  enrollmentPeriodByCode?: Maybe<IEnrollmentPeriod>;
  /** Retrieves an EnrollmentPeriod by its ID. */
  enrollmentPeriodByDates?: Maybe<IEnrollmentPeriod>;
  /** Retrieves a list of EnrollmentPeriods based on provided criteria and optional pagination. */
  enrollmentPeriods: IEnrollmentPeriodListResponse;
  /**
   * ### Get enrollment verified student count by billing period
   * Returns a count of enrollment verified students for a given billing period.
   * This is a temporary solution provided by AFS in advance of a solution provided by
   * the Academic Enrollment Service. AFS needs this number to be the exact same number
   * used by the AFS backend for validations.
   *
   * #### Authorization:
   *
   * ##### permissions
   * read:AP_financialsTuition
   *
   * ##### scopes (m2m)
   * No scope authorization required
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://afs.guildeducation.com` ]
   */
  enrollmentVerifiedStudentCount?: Maybe<Scalars['Int']['output']>;
  epol_getEmployerInfo?: Maybe<IEmployerInfo>;
  epol_getEmployerInstitutions?: Maybe<IEmployerInstitutions>;
  epol_getPublicEmployerInfo?: Maybe<IEmployerInfoPublicResources>;
  /** Retrieves Exchange Date Formula by academicPartnerId and exchangeDateTypeId */
  exchangeDateFormula?: Maybe<IExchangeDateFormula>;
  /** Retrieves Exchange Date Formulas by academicPartnerId */
  exchangeDateFormulas: Array<IExchangeDateFormula>;
  /**
   * Retrieves a list of FieldOfStudy entities.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read`, `member` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:fieldsOfStudy` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   *   - top level field of study's are "parent" field of studies
   *   - children field of study's contain a parent field of study for easy identification if these are later separated
   *   - children field of study's parent object does not include the `children` key to prevent cyclic refrences
   */
  fieldsOfStudy: Array<IParentFieldOfStudy>;
  /**
   * ### Get Validation Results
   * Returns a list of validation results (ingest validation results or release validation results,
   * for the respective queries). Currently only failures are persisted in the DB, so the default
   * resultOutcome filter is to return failures only which amounts to all data available.
   */
  financialIngestValidationResults: Array<IFinancialValidationResult>;
  financialReleaseValidationResults: Array<IFinancialValidationResult>;
  funding_bulkGetSpendByProduct: IFunding_BulkGetSpendByProductResponse;
  funding_bulkGetStudentSpendByAchievementType: Array<
    Maybe<IFunding_StudentSpendResponseWithGuildUuidAndAchievementType>
  >;
  funding_bulkGetStudentSpendByProgramId: Array<
    Maybe<IFunding_StudentSpendResponseWithGuildUuidAndProgramId>
  >;
  funding_getAdjustmentFileUploadUrl: IFunding_PresignedFileUrl;
  funding_getBenefitPeriodsByEmployerId?: Maybe<IFunding_GetBenefitPeriodsByEmployerIdResponse>;
  funding_getCustomBenefitConfiguration?: Maybe<IFunding_GetCustomBenefitConfigurationResponse>;
  funding_getLearnerSpendReportUrl?: Maybe<IFunding_GetLearningSpendReportUrlResponse>;
  funding_getSpendByProduct: IFunding_GetSpendByProductResponse;
  funding_getStudentSpend: IFunding_GetStudentSpendResponse;
  funding_getTaxPeriods: IFunding_GetTaxPeriodsResponse;
  funding_listAdjustments?: Maybe<IFunding_ListAdjustmentsResponse>;
  funding_listLearnerSpendReports?: Maybe<IFunding_ListLearnerSpendReportsResponse>;
  fundingResultInformation: IFundingResultInformationData;
  gatewayMemberUsers: Array<Maybe<IMemberUser>>;
  getActiveEmployerLevelRule?: Maybe<IGetActiveRuleResponse>;
  getActiveEmployerPolicy?: Maybe<IEmployerPolicyResponse>;
  getActiveRule?: Maybe<IGetActiveRuleResponse>;
  getBatchAcademicPartnersByIds: Array<IAcademicPartner>;
  /**
   * Retrieves a list of GuildPrograms when provided a list of UUIDS.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:ep_catalog_lookup` ]
   *
   * ##### audiences (m2m)
   * [ `https://program-service.guildeducation.com`, `graphql-gateway.guild-cloud.com`, `https://frontend.guild-cloud.com` ]
   *
   * #### Example:
   * ```
   * query getBatchGuildProgramsByIds($ids: [ID!]!) {
   *     getBatchGuildProgramsByIds(ids: $ids) {
   *       id
   *       name
   *       achievementTypeId
   *       isTest
   *       academicPartner {
   *           id
   *           name
   *       }
   *     }
   *   }
   *   {
   *     "getBatchGuildProgramsByIds": [
   *       {
   *         "id": "<uuid>",
   *         "name": "AAS in Accounting",
   *         "achievementTypeId": "cc24062e-1597-4638-a0d5-018c065a9b14",
   *         "isTest": false,
   *         "academicPartner": {
   *             "id": "<ap_uuid>",
   *             "name": "Ivy Tech Community College"
   *         }
   *       },
   *       {
   *         "id": "<uuid>",
   *         "name": "BS in Accounting",
   *         "achievementTypeId": "9de23578-1482-47c2-9869-589572649f44",
   *         "isTest": false,
   *         "academicPartner": {
   *             "id": "<ap_uuid>",
   *             "name": "Ivy Tech Community College"
   *         }
   *       }
   *     ]
   *   }
   * ```
   *
   * #### Additional Notes:
   * - Used to merge `GuildProgram` records in the federated graphql gateway
   */
  getBatchGuildProgramsByIds: Array<IGuildProgram>;
  /**
   * Retrieves a list of Partner Programs in a batch query by AP Code.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   * #### Additional Notes:
   * - This resolver allows for batch processing of many codes for a single AP.
   * - This is the recommended query to use when processing a large group of records, for instance, as part of a file upload.
   */
  getBatchPartnerProgramsByCodes: Array<IPartnerProgram>;
  /**
   * Retrieves a list of Partner Programs in a batch query.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   * - When this resolver is being used as part of the federated gateway's merging, functionality is limited to getting the state with "asOf" set to the current time and omitting test data.
   * - This resolver can be directly used by consumers with full input querying control.
   */
  getBatchPartnerProgramsByIds: Array<IPartnerProgram>;
  getBetaUser?: Maybe<IBetaUser>;
  getCoachingLinks?: Maybe<ICoachingLinks>;
  getDatasetsForEmployer?: Maybe<Array<Maybe<IDataset>>>;
  getEligibility?: Maybe<IEligibilityResult>;
  getEligibilityEmployeePreview?: Maybe<IEligibilibityPreviewResponse>;
  getEligibilityRuleCensus?: Maybe<ICensusResponse>;
  getEmployees: IEmployeeLookupResult;
  /** Required scopes for getEmployers: 'read:epconfig_employer_info',  'read:all-employer-metadata' */
  getEmployer?: Maybe<IEmployer>;
  getEmployerConfig?: Maybe<IPathwaysEmployerConfig>;
  getEmployerPolicyById?: Maybe<IEmployerPolicyResponse>;
  /** Required scopes for getEmployers: 'read:epconfig_employer_info',  'read:all-employer-metadata' */
  getEmployers: Array<Maybe<IEmployer>>;
  getEmployerStandards?: Maybe<IEmployerStandardsResponse>;
  /** Get processing status of async file upload given the name of the file in S3 */
  getEnrollmentIngestProcessingStatus: IGetEnrollmentIngestProcessingStatusResponse;
  getPublicEncryptionKey?: Maybe<IPublicKey>;
  getRemotes?: Maybe<Array<Maybe<IRemoteRegistrationItem>>>;
  getRule?: Maybe<IRuleResponse>;
  getSampleFileInfo?: Maybe<Array<Maybe<ISampleFile>>>;
  /**
   * Retrieves a Guild Program by UUID.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:ep_catalog_lookup` ]
   *
   * ##### audiences (m2m)
   * [ `https://program-service.guildeducation.com`, `graphql-gateway.guild-cloud.com`, `https://frontend.guild-cloud.com` ]
   *
   * #### Example:
   * ```
   * query GuildProgram($id: ID!) {
   *   guildProgram(id: $id) {
   *       id
   *       name
   *       achievementType
   *       isTest
   *       academicPartner {
   *           id
   *           name
   *       }
   *   }
   * }
   * {
   *   "guildProgram": {
   *     "id": "<uuid>",
   *     "name": "AAS in Accounting",
   *     "achievementTypeId": "cc24062e-1597-4638-a0d5-018c065a9b14",
   *     "isTest": false,
   *     "academicPartner": {
   *         "id": "<ap_uuid>",
   *         "name": "Ivy Tech Community College"
   *     }
   *   }
   * }
   * ```
   *
   * #### Additional Notes:
   * - Used to merge `GuildProgram` records in the federated graphql gateway
   */
  guildProgram?: Maybe<IGuildProgram>;
  /**
   * Retrieves a paginated list of `GuildProgram` entities, by filtering against various criteria.
   * Typically used by Academic Partner UUID or by searching against names or ids.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:ep_catalog_lookup` ]
   *
   * ##### audiences (m2m)
   * [ `https://program-service.guildeducation.com`, `graphql-gateway.guild-cloud.com`, `https://frontend.guild-cloud.com` ]
   *
   * #### Example:
   * ```
   * query GuildPrograms(
   *   $criteria: GuildProgramListInput!
   *   $paginationInput: PSPaginationInput
   *   $orderByInput: [PSOrderBySortInput!]
   * ) {
   *   guildPrograms(
   *     criteria: $criteria
   *     paginationInput: $paginationInput
   *     orderByInput: $orderByInput
   *   ) {
   *     count
   *     data {
   *         id
   *         academicPartner {
   *             id
   *         }
   *         name
   *         createdAt
   *         createdBy
   *         isTest
   *         updatedAt
   *         updatedBy
   *         offeringId
   *         }
   *     errors {
   *         errorMessage
   *         errorType
   *         }
   *     page
   *     statusCode
   *     total
   *     totalPages
   *   }
   * }
   * {
   *   "guildPrograms": {
   *       "count": 2,
   *       "data": [
   *         {
   *           "id": "05e702aa-0ead-4f18-80e7-aba22e125644",
   *           "academicPartner": {
   *               "id": "41fbb098-c1be-41c6-b2ea-1feaacd90618"
   *           },
   *           "name": "AS in General Studies Nursing",
   *           "createdAt": "2023-01-17T21:22:49.000Z",
   *           "createdBy": "initial_backfill_script",
   *           "isTest": false,
   *           "updatedAt": "2023-01-17T21:22:49.000Z",
   *           "updatedBy": "initial_backfill_script",
   *           "offeringId": "2814"
   *         },
   *         {
   *           "id": "20f507a4-f404-40b3-8b14-521191f3e8ef",
   *           "academicPartner": {
   *               "id": "41fbb098-c1be-41c6-b2ea-1feaacd90618"
   *           },
   *           "name": "MS in Nursing, Nursing Education",
   *           "createdAt": "2023-01-17T21:22:49.000Z",
   *           "createdBy": "initial_backfill_script",
   *           "isTest": false,
   *           "updatedAt": "2023-01-17T21:22:49.000Z",
   *           "updatedBy": "initial_backfill_script",
   *           "offeringId": "2773"
   *         }
   *       ],
   *       "errors": [],
   *       "page": 1,
   *       "statusCode": 200,
   *       "total": 16,
   *       "totalPages": 8
   *   }
   * ```
   *
   * #### Additional Notes:
   * - Default page size is 50
   * - At least one criteria parameter must be set
   * - Default ordering is by ap and name
   */
  guildPrograms: IGuildProgramListResponse;
  healthCheck?: Maybe<Scalars['Boolean']['output']>;
  institution?: Maybe<IInstitution>;
  institutions: IInstitutionListResponse;
  internalUser?: Maybe<IInternalUser>;
  internalUsers: Array<Maybe<IInternalUser>>;
  /**
   * ### Get Latest BillingPeriodCohort Per BillingType
   * Returns the latest BillingPeriodCohort for each BillingPeriodCohortBillingType.
   * Requires a billingPeriodId to be provided.
   *
   * #### Authorization:
   *
   * ##### permissions
   * read:AP_financialsTuition
   *
   * ##### scopes (m2m)
   * No scope authorization required
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://afs.guildeducation.com` ]
   */
  latestBillingPeriodCohortPerBillingType?: Maybe<ILatestBillingPeriodCohortsPerBillingTypeResponse>;
  learningMarketplaceAvailability: ILearningMarketplaceAvailabilityDecision;
  listAllProgramEnrollmentsByGuildUuids: Array<IAs_ProgramEnrollment>;
  listEmployerPolicies?: Maybe<IEmployerPolicyListResponse>;
  /** Get list of enrollment Data Ingest Errors */
  listEnrollmentDataIngestErrors: IListEnrollmentDataIngestErrorsResponse;
  listSFTPFiles?: Maybe<Array<Maybe<IFolder>>>;
  memberByStudentIdentity?: Maybe<IMemberUser>;
  memberUser?: Maybe<IMemberUser>;
  memberUsers?: Maybe<IMemberUsersResponse>;
  memberUsersFromExternalIds?: Maybe<IMemberUsersFromExternalIdsResponse>;
  microsite?: Maybe<IMicrosite>;
  /**
   * Retrieves a Partner Program by ID
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   *   - none_
   */
  partnerProgram?: Maybe<IPartnerProgram>;
  /**
   * Retrieves a Partner Program by AP Code. This query is critical when dealing with AP-provided identifiers.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   * - Consuming services should persist PartnerProgram.id and not the code for future look-ups.
   * - Academic Foundations recommends storing any incoming requests with input information as metadata, however.
   */
  partnerProgramByCode?: Maybe<IPartnerProgram>;
  /**
   * Retrieves a list of ApProgramCodes
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *
   * #### Additional Notes:
   */
  partnerProgramCodes: Array<IApProgramCode>;
  /**
   * Retrieves a paginated list of Partner Programs based on input criteria.
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   * - Most commonly used to get a list of Partner Programs for a Guild Program Id
   */
  partnerPrograms: IPartnerProgramListResponse;
  pathway?: Maybe<IPathway>;
  pathways: Array<Maybe<IPathway>>;
  pathwaysForEmployer: Array<Maybe<IPathwayConfig>>;
  paymentNetworkAvailability: IPaymentNetworkAvailabilityDecision;
  plan_heartbeat?: Maybe<IHeartbeatResponse>;
  pongHeartbeat: IHeartbeatResponse;
  population_heartbeat?: Maybe<IHeartbeatResponse>;
  price?: Maybe<IPrice>;
  prices: Array<IPrice>;
  pricesByProgram: Array<IPrice>;
  priceType?: Maybe<IPriceType>;
  priceTypes: Array<IPriceType>;
  /** Get list of Program Enrollments by BillingPeriods */
  programEnrollmentsByBillingPeriod?: Maybe<IProgramEnrollmentListResponse>;
  /** Get list of Program Enrollments by Guild UUID */
  programEnrollmentsByGuildUuid: IProgramEnrollmentListResponse;
  /** Get list of Program Enrollments for a list of Guild UUIDs */
  programEnrollmentsByGuildUuids: IProgramEnrollmentListResponse;
  serverStatus: IServerStatusResponse;
  studentIdentities?: Maybe<Array<IStudentIdentity>>;
  studentIdentitiesForMember?: Maybe<Array<IStudentIdentity>>;
  studentIdentity?: Maybe<IStudentIdentity>;
  studentSpend: IStudentSpend;
  /**
   * ### Get Student Transactions
   * Requires either both academicPartnerId and termId to be provided, or internalStudentIds to be provided in the filter.
   *
   * #### Authorization:
   *
   * ##### roles
   * No role authorization required
   *
   * ##### scopes (m2m)
   * No scope authorization required
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://afs.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Errors:
   *   - ValidationError: Invalid input
   */
  studentTransactions?: Maybe<Array<IStudentTransaction>>;
  /** Retrieves a Term by ID */
  term?: Maybe<ITerm>;
  /** Retrieves a Term by Code */
  termByCode?: Maybe<ITerm>;
  /** Retrieves a list of Terms with criteria/pagination */
  terms: ITermListResponse;
  /** Retrieves many Terms by Code */
  termsByCodes: ITermsByCodesResponse;
  transactionRegistry_helloWorld: ITransactionRegistry_HelloWorldResponse;
  /**
   * Retrieves a list of unlinked ApProgramCodes.
   * These codes require remediation action by operations by:
   *   - aliasing to an existing PartnerProgram
   *   - linking this code to a `GuildProgram` (and thereby creating a new PartnerProgram)
   *   - deleting this unlinked code, in cases where neither action above is appropriate
   *
   *
   * #### Authorization:
   *
   * ##### roles
   * [ `guildAdmin`, `guildSuperUser`, `guildMember`, `multiApAdmin`, `apAdmin`, `apMember`, `admin`, `superadmin`, `bat-admin`, `bat-merchandising`, `bat-read` ]
   *
   * ##### scopes (m2m)
   * [ `PS:read:partner-program` ]
   *
   * ##### audiences (m2m)
   * [ `graphql-gateway.guild-cloud.com`, `https://program-service.guildeducation.com` ]
   *
   * #### Example:
   *   ```
   *     TODO
   *   ```
   *
   * #### Additional Notes:
   * - drives Programs UI views
   */
  unlinkedCodes: Array<IApProgramCode>;
};

export type IQueryAcademicCalendarArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryAcademicCalendarsArgs = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<IAcademicCalendarFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IQueryAcademicCalendarServiceStatusArgs = {
  words?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IQueryAcademicPartnerArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryAcademicPartnerByShortnameArgs = {
  shortName: Scalars['String']['input'];
};

export type IQueryAcademicPartnersArgs = {
  filters?: InputMaybe<IApsFilterInput>;
  orderBy?: InputMaybe<IApsOrderByInput>;
  paginationInput?: InputMaybe<IApsPaginationInput>;
};

export type IQueryAcademicPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryAcademicPeriodsArgs = {
  calendarId: Scalars['ID']['input'];
};

export type IQueryAchievementTypeArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryAnyUserTypeArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type IQueryApplicationArgs = {
  uuid: Scalars['ID']['input'];
};

export type IQueryBatchTermByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryBenefitOverviewSimplifiedArgs = {
  employerUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type IQueryBenefitOverviewSummaryArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employerUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type IQueryBillingPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryBillingPeriodByCodeArgs = {
  academicPartnerId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type IQueryBillingPeriodsArgs = {
  criteria: IBillingPeriodsFilters;
  orderBySort?: InputMaybe<IBillingPeriodsOrderBySortInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IQueryBookmarksArgs = {
  userOverrides?: InputMaybe<IUserOverridesInput>;
};

export type IQueryCatalogProgramArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  employerSlug?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  planUuid?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};

export type IQueryCatalogProgramsArgs = {
  programUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userOverrides?: InputMaybe<IUserOverridesInput>;
  withoutDates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryCatalogProgramUuidArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['ID']['input'];
};

export type IQueryCourseEnrollmentsByBillingPeriodArgs = {
  input: ICourseEnrollmentsByBillingPeriodInput;
};

export type IQueryCourseEnrollmentsByGuildUuidArgs = {
  input: ICourseEnrollmentsByGuildUuidInput;
};

export type IQueryCoverageSummariesArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employerUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type IQueryCycGetEmployerConfigArgs = {
  employerUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryCycListMemberProgressArgs = {
  memberUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryDecryptAndDownloadFileArgs = {
  employerUUID: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
};

export type IQueryEligibilityAndCoverageSummariesArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employerUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type IQueryEligibilitySummaryArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employerUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type IQueryEmployerIdentitiesArgs = {
  userId: Scalars['ID']['input'];
};

export type IQueryEnrollmentPeriodArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryEnrollmentPeriodByCodeArgs = {
  academicPartnerId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type IQueryEnrollmentPeriodByDatesArgs = {
  academicPartnerId: Scalars['ID']['input'];
  billingPeriodCode: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type IQueryEnrollmentPeriodsArgs = {
  criteria: IEnrollmentPeriodsFilters;
  orderBySort?: InputMaybe<IEnrollmentPeriodsOrderBySortInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IQueryEnrollmentVerifiedStudentCountArgs = {
  billingPeriodId: Scalars['ID']['input'];
};

export type IQueryEpol_GetEmployerInfoArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IQueryEpol_GetEmployerInstitutionsArgs = {
  employerId: Scalars['ID']['input'];
  institutionId?: InputMaybe<Scalars['ID']['input']>;
  paymentModality?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryEpol_GetPublicEmployerInfoArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IQueryExchangeDateFormulaArgs = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  exchangeDateTypeId: Scalars['ID']['input'];
};

export type IQueryExchangeDateFormulasArgs = {
  academicPartnerId: Scalars['ID']['input'];
};

export type IQueryFieldsOfStudyArgs = {
  options?: InputMaybe<IFieldsOfStudyInput>;
};

export type IQueryFinancialIngestValidationResultsArgs = {
  request: IFinancialIngestValidationResultsRequest;
};

export type IQueryFinancialReleaseValidationResultsArgs = {
  request: IFinancialReleaseValidationResultsRequest;
};

export type IQueryFunding_BulkGetSpendByProductArgs = {
  input?: InputMaybe<IFunding_BulkGetSpendByProductInput>;
};

export type IQueryFunding_BulkGetStudentSpendByAchievementTypeArgs = {
  input?: InputMaybe<IFunding_BulkGetStudentSpendByAchievementType>;
};

export type IQueryFunding_BulkGetStudentSpendByProgramIdArgs = {
  input?: InputMaybe<IFunding_BulkGetStudentSpendByProgramId>;
};

export type IQueryFunding_GetAdjustmentFileUploadUrlArgs = {
  input?: InputMaybe<IFunding_GetAdjustmentFileUploadUrlInput>;
};

export type IQueryFunding_GetBenefitPeriodsByEmployerIdArgs = {
  input?: InputMaybe<IFunding_GetBenefitPeriodsByEmployerIdInput>;
};

export type IQueryFunding_GetCustomBenefitConfigurationArgs = {
  input?: InputMaybe<IFunding_GetCustomBenefitConfiguration>;
};

export type IQueryFunding_GetLearnerSpendReportUrlArgs = {
  input?: InputMaybe<IFunding_GetLearnerSpendReportUrlInput>;
};

export type IQueryFunding_GetSpendByProductArgs = {
  input?: InputMaybe<IFunding_GetSpendByProductInput>;
};

export type IQueryFunding_GetStudentSpendArgs = {
  input?: InputMaybe<IFunding_GetStudentSpend>;
};

export type IQueryFunding_GetTaxPeriodsArgs = {
  input?: InputMaybe<IFunding_GetTaxPeriodsInput>;
};

export type IQueryFunding_ListAdjustmentsArgs = {
  input?: InputMaybe<IFunding_ListAdjustments>;
};

export type IQueryFunding_ListLearnerSpendReportsArgs = {
  input?: InputMaybe<IFunding_ListLearnerSpendReportsInput>;
};

export type IQueryFundingResultInformationArgs = {
  achievementType?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['ID']['input'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
  institutionId?: InputMaybe<Scalars['ID']['input']>;
  paymentModality: IPaymentModality;
  programId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type IQueryGatewayMemberUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryGetActiveEmployerLevelRuleArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  eligibilityType: IEligibilityType;
  employerId: Scalars['ID']['input'];
};

export type IQueryGetActiveEmployerPolicyArgs = {
  effective?: InputMaybe<Scalars['AWSDateTime']['input']>;
  employerId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type IQueryGetActiveRuleArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  coveragePackageId: Scalars['ID']['input'];
  eligibilityType: IEligibilityType;
  employerId: Scalars['ID']['input'];
};

export type IQueryGetBatchAcademicPartnersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryGetBatchGuildProgramsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryGetBatchPartnerProgramsByCodesArgs = {
  academicPartnerId: Scalars['ID']['input'];
  apProgramCodes: Array<Scalars['String']['input']>;
  asOf?: InputMaybe<Scalars['String']['input']>;
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryGetBatchPartnerProgramsByIdsArgs = {
  asOf?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryGetBetaUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employerId?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryGetCoachingLinksArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryGetDatasetsForEmployerArgs = {
  employerUUID: Scalars['ID']['input'];
};

export type IQueryGetEligibilityArgs = {
  academicPartnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  coveragePackageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employee?: InputMaybe<Scalars['AWSJSON']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employerId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type IQueryGetEligibilityEmployeePreviewArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employee?: InputMaybe<Scalars['AWSJSON']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  rules: Scalars['AWSJSON']['input'];
};

export type IQueryGetEligibilityRuleCensusArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IQueryGetEmployeesArgs = {
  employerId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
};

export type IQueryGetEmployerArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryGetEmployerConfigArgs = {
  employerId: Scalars['ID']['input'];
};

export type IQueryGetEmployerPolicyByIdArgs = {
  employerId: Scalars['ID']['input'];
  policyId: Scalars['ID']['input'];
};

export type IQueryGetEmployerStandardsArgs = {
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  coveragePackageId?: InputMaybe<Scalars['ID']['input']>;
  employerId: Scalars['ID']['input'];
};

export type IQueryGetEnrollmentIngestProcessingStatusArgs = {
  filePath: Scalars['String']['input'];
};

export type IQueryGetPublicEncryptionKeyArgs = {
  employerUUID: Scalars['ID']['input'];
};

export type IQueryGetRemotesArgs = {
  appId: Scalars['String']['input'];
};

export type IQueryGetRuleArgs = {
  asOf?: InputMaybe<Scalars['AWSDate']['input']>;
  coveragePackageId?: InputMaybe<Scalars['ID']['input']>;
  eligibilityType?: InputMaybe<IEligibilityType>;
  employerId: Scalars['ID']['input'];
};

export type IQueryGetSampleFileInfoArgs = {
  employerUUID: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type IQueryGuildProgramArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryGuildProgramsArgs = {
  criteria: IGuildProgramListInput;
  orderByInput?: InputMaybe<Array<IPsOrderBySortInput>>;
  paginationInput?: InputMaybe<IPsPaginationInput>;
};

export type IQueryInstitutionArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryInstitutionsArgs = {
  filters: IInstitutionFilterInput;
  paginationInput?: InputMaybe<IInstitutionPaginationInput>;
};

export type IQueryInternalUserArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryInternalUsersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryLatestBillingPeriodCohortPerBillingTypeArgs = {
  billingPeriodId: Scalars['ID']['input'];
};

export type IQueryLearningMarketplaceAvailabilityArgs = {
  employerId: Scalars['ID']['input'];
  institutionId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type IQueryListAllProgramEnrollmentsByGuildUuidsArgs = {
  guildUuids: Array<Scalars['String']['input']>;
};

export type IQueryListEmployerPoliciesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  employerId: Scalars['ID']['input'];
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IQueryListEnrollmentDataIngestErrorsArgs = {
  input: IListEnrollmentDataIngestErrorsInput;
};

export type IQueryListSftpFilesArgs = {
  employerUUID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
};

export type IQueryMemberByStudentIdentityArgs = {
  internalStudentId: Scalars['ID']['input'];
};

export type IQueryMemberUserArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryMemberUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryMemberUsersFromExternalIdsArgs = {
  externalIds: Array<Scalars['String']['input']>;
};

export type IQueryMicrositeArgs = {
  entityId: Scalars['String']['input'];
};

export type IQueryPartnerProgramArgs = {
  asOf?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryPartnerProgramByCodeArgs = {
  academicPartnerId: Scalars['ID']['input'];
  apProgramCode: Scalars['String']['input'];
  asOf?: InputMaybe<Scalars['String']['input']>;
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryPartnerProgramCodesArgs = {
  academicPartnerId: Scalars['String']['input'];
  includeTestData?: InputMaybe<Scalars['Boolean']['input']>;
  isLinked?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryPartnerProgramsArgs = {
  criteria: IPartnerProgramListInput;
  orderByInput?: InputMaybe<Array<IPsOrderBySortInput>>;
  paginationInput?: InputMaybe<IPsPaginationInput>;
};

export type IQueryPathwayArgs = {
  employerId: Scalars['ID']['input'];
  pathwayId: Scalars['ID']['input'];
};

export type IQueryPathwaysArgs = {
  employerId: Scalars['ID']['input'];
};

export type IQueryPathwaysForEmployerArgs = {
  employerId: Scalars['ID']['input'];
};

export type IQueryPaymentNetworkAvailabilityArgs = {
  achievementType: Scalars['String']['input'];
  employerId: Scalars['ID']['input'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
  institutionId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type IQueryPongHeartbeatArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryPriceArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryPricesArgs = {
  filters?: InputMaybe<Array<IPriceFilter>>;
  ids: Array<Scalars['ID']['input']>;
};

export type IQueryPricesByProgramArgs = {
  academicPartnerUuid: Scalars['ID']['input'];
  filters?: InputMaybe<Array<IPriceFilter>>;
  programUuid: Scalars['ID']['input'];
};

export type IQueryPriceTypeArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryProgramEnrollmentsByBillingPeriodArgs = {
  input: IProgramEnrollmentsByBillingPeriodInput;
};

export type IQueryProgramEnrollmentsByGuildUuidArgs = {
  input: IProgramEnrollmentsByGuildUuidInput;
};

export type IQueryProgramEnrollmentsByGuildUuidsArgs = {
  input: IProgramEnrollmentsByGuildUuidsInput;
};

export type IQueryServerStatusArgs = {
  words?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IQueryStudentIdentitiesArgs = {
  internalStudentIds: Array<Scalars['ID']['input']>;
};

export type IQueryStudentIdentitiesForMemberArgs = {
  memberId: Scalars['ID']['input'];
};

export type IQueryStudentIdentityArgs = {
  internalStudentId: Scalars['ID']['input'];
};

export type IQueryStudentSpendArgs = {
  key: IStudentSpendKey;
};

export type IQueryStudentTransactionsArgs = {
  filter: IStudentTransactionFilterInput;
};

export type IQueryTermArgs = {
  id: Scalars['ID']['input'];
};

export type IQueryTermByCodeArgs = {
  academicPartnerId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type IQueryTermsArgs = {
  criteria: ITermsFilters;
  orderBySort?: InputMaybe<ITermsOrderBySortInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IQueryTermsByCodesArgs = {
  academicPartnerId: Scalars['ID']['input'];
  codes: Array<Scalars['String']['input']>;
};

export type IQueryTransactionRegistry_HelloWorldArgs = {
  input?: InputMaybe<ITransactionRegistry_HelloWorld>;
};

export type IQueryUnlinkedCodesArgs = {
  academicPartnerId: Scalars['String']['input'];
  includeTestData?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IReadFromAesEnum {
  DISABLED = 'DISABLED',
  PROD_ENABLED = 'PROD_ENABLED',
  UAT_ENABLED = 'UAT_ENABLED',
}

export type IReleaseBillingPeriodCohortRequest = {
  billingPeriodCohortId: Scalars['ID']['input'];
  isReleaseWithOverride: Scalars['Boolean']['input'];
  overrideExplanation?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IRemoteRegistrationItem = {
  appId: Scalars['String']['output'];
  availableInProduction: Scalars['Boolean']['output'];
  descriptiveName: Scalars['String']['output'];
  includeInNavigation: Scalars['Boolean']['output'];
  includeInSitemap: Scalars['Boolean']['output'];
  module: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  remoteUrl?: Maybe<Scalars['String']['output']>;
  repoName: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  sideNavModuleName?: Maybe<Scalars['String']['output']>;
  siteMapSubpathLinks?: Maybe<Array<Maybe<ISubmapLink>>>;
};

export type IResource = {
  after_text?: Maybe<Scalars['String']['output']>;
  before_text?: Maybe<Scalars['String']['output']>;
  inline_url?: Maybe<Scalars['String']['output']>;
  url_text?: Maybe<Scalars['String']['output']>;
};

export type IResponse = {
  body?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type IRollcallAcademicPeriodInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type IRollcallBillingAndEnrollmentPeriodsResponse = {
  nextAcademicPeriodId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Form input on page 1 of the Rollcall Calendar form */
export type IRollcallCalendarAndAcademicPeriodsInput = {
  academicPartnerId: Scalars['String']['input'];
  academicPeriods: Array<IRollcallAcademicPeriodInput>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  calendarName: Scalars['String']['input'];
  calendarNotes: Scalars['String']['input'];
  commitmentDateAmount: Scalars['Int']['input'];
  commitmentDateType: ICalendarFormulaUnit;
};

export type IRollcallCalendarAndAcademicPeriodsResponse = {
  calendarId: Scalars['ID']['output'];
  nextAcademicPeriodId: Scalars['ID']['output'];
};

export type IRollcallDataExchangeDatesResponse = {
  success: Scalars['Boolean']['output'];
};

export type IRule = {
  active: Scalars['Boolean']['output'];
  asOf?: Maybe<Scalars['AWSDateTime']['output']>;
  coveragePackageId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  criteria: Scalars['AWSJSON']['output'];
  descriptions?: Maybe<Scalars['AWSJSON']['output']>;
  eligibilityType: IEligibilityType;
  employerId: Scalars['ID']['output'];
  guildApprovalDate?: Maybe<Scalars['AWSDateTime']['output']>;
  guildApprover?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  partnerApprovalDate?: Maybe<Scalars['AWSDateTime']['output']>;
  partnerApprover?: Maybe<Scalars['String']['output']>;
  reasonDetail?: Maybe<Scalars['String']['output']>;
  ruleLevel: IRuleLevel;
  ruleName?: Maybe<Scalars['String']['output']>;
  standards?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum IRuleLevel {
  COVERAGEPACKAGE = 'CoveragePackage',
  EMPLOYER = 'Employer',
}

export type IRuleResponse = {
  /** Data contains the response value */
  data?: Maybe<Array<IRule>>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
};

export type IS3FileMetadata = {
  fileName?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ISampleFile = {
  active?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
  employerUUID?: Maybe<Scalars['ID']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<Maybe<IField>>>;
  filePath?: Maybe<Scalars['AWSURL']['output']>;
  headers?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uploadURL?: Maybe<Scalars['AWSJSON']['output']>;
};

export type ISaveEmployerConfigInput = {
  employerId: Scalars['ID']['input'];
  pathwaysEnabled: Scalars['Boolean']['input'];
};

export type ISaveRuleResponse = {
  /** Data contains the response value */
  data?: Maybe<IRule>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
};

export type ISchoolAttendance = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  degreeEarned?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isInternational?: Maybe<Scalars['Boolean']['output']>;
  postalState?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  studentFormerName?: Maybe<Scalars['String']['output']>;
  type: IOption;
  updatedAt: Scalars['Date']['output'];
};

export type IServerStatus = {
  message?: Maybe<Scalars['String']['output']>;
  responseId: Scalars['String']['output'];
  words?: Maybe<Array<Scalars['String']['output']>>;
};

export type IServerStatusResponse = IAesResponse & {
  /** Data contains the response value */
  data?: Maybe<IServerStatus>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Status code */
  statusCode: Scalars['Int']['output'];
};

export type ISessionCreateInput = {
  /** Term code */
  code: Scalars['String']['input'];
  /** Term dates object */
  dates: ITermDatesInput;
  /** Term name */
  name: Scalars['String']['input'];
};

export type ISftp = {
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  employerUUID: Scalars['ID']['output'];
  parentFolderName: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum IShortProgramKind {
  ASSOCIATES = 'ASSOCIATES',
  BACHELORS = 'BACHELORS',
  CERTIFICATE = 'CERTIFICATE',
  COLLEGE_PREP = 'COLLEGE_PREP',
  DOCTORAL = 'DOCTORAL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  LANGUAGE = 'LANGUAGE',
  MASTERS = 'MASTERS',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT',
}

export enum ISortFieldCourseEnrollment {
  /** Number of course credits */
  CREDITS = 'credits',
  /** Program code Course Enrollment is associated with */
  EXTERNALPROGRAMCODE = 'externalProgramCode',
  /** External Student ID */
  EXTERNALSTUDENTIDENTIFIER = 'externalStudentIdentifier',
  /** Date Course Enrollment was last updated */
  RECORDEDAT = 'recordedAt',
}

export enum ISortFieldProgramEnrollment {
  /** The student's Gpa over the duration of their program */
  CUMULATIVEGPA = 'cumulativeGpa',
  /** External Student ID */
  EXTERNALSTUDENTIDENTIFIER = 'externalStudentIdentifier',
  /** Date Program Enrollment was last updated */
  RECORDEDAT = 'recordedAt',
  /** Date Program Enrollment starts */
  STARTDATE = 'startDate',
}

export enum ISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ISponsorshipProductContext = {
  achievementType: Scalars['String']['input'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
};

export enum IStandardProductName {
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  TUITION_ASSISTANCE = 'TUITION_ASSISTANCE',
  TUITION_REIMBURSEMENT = 'TUITION_REIMBURSEMENT',
}

export type IStandards = {
  creditHourMinimum?: Maybe<Scalars['Int']['output']>;
  gpaMinimum?: Maybe<IGpaMinimum>;
};

export type IStudent_Balance = {
  amountRemainingCents?: Maybe<Scalars['Int']['output']>;
  amountSpentCents: Scalars['Int']['output'];
  amountTuitionSpentCents: Scalars['Int']['output'];
  benefitPackageId?: Maybe<Scalars['ID']['output']>;
  capAsOf: Scalars['AWSDate']['output'];
  employerId: Scalars['ID']['output'];
  expenseTypeIdsCoveredByTuitionCap?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  guildUuid: Scalars['ID']['output'];
  nonTuitionExpenseTypes: Array<Maybe<INontuition_Expense>>;
  spendAsOf: Scalars['AWSDate']['output'];
  tuitionFundingLimitCents?: Maybe<Scalars['Int']['output']>;
};

export type IStudent_Balance_Debug = {
  fundingCapError?: Maybe<Scalars['String']['output']>;
};

/** StudentIdentity canonical type, managed by the student identity service. */
export type IStudentIdentity = {
  academicPartner?: Maybe<IAcademicPartner>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  /** This field is managed by the student identity service via the memberByStudentIdentity query */
  memberUser?: Maybe<IMemberUser>;
  partnerStudentId?: Maybe<Scalars['ID']['output']>;
};

export type IStudentSpend = {
  balance: IBalance;
};

export type IStudentSpendKey = {
  employerId: Scalars['ID']['input'];
  product: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['ID']['input']>;
  spendAsOf: Scalars['AWSDateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type IStudentTransaction = {
  academicPartner: IAcademicPartner;
  assessedTuition: Scalars['Float']['output'];
  batchId: Scalars['ID']['output'];
  books: Scalars['Float']['output'];
  discounts: Scalars['Float']['output'];
  fees: Scalars['Float']['output'];
  grants: Scalars['Float']['output'];
  grossTuition: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  netTuition: Scalars['Float']['output'];
  other: Scalars['Float']['output'];
  recordType: IStudentTransactionRecordType;
  releasedAt?: Maybe<Scalars['String']['output']>;
  state: IStudentTransactionState;
  student: IStudentIdentity;
  term: ITerm;
};

export enum IStudentTransactionFilterActiveEnum {
  ALL = 'ALL',
  FALSE = 'FALSE',
  TRUE = 'TRUE',
}

export type IStudentTransactionFilterInput = {
  academicPartnerId: Scalars['ID']['input'];
  /** Filter by whether the transaction is active or not. Defaults to 'true'. */
  active?: InputMaybe<IStudentTransactionFilterActiveEnum>;
  internalStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  termId?: InputMaybe<Scalars['ID']['input']>;
};

export enum IStudentTransactionRecordType {
  FINANCIALS = 'FINANCIALS',
  RECONCILIATION = 'RECONCILIATION',
}

export enum IStudentTransactionState {
  FAILED_QA = 'FAILED_QA',
  PASSED_QA = 'PASSED_QA',
  RELEASED = 'RELEASED',
  RELEASED_WITH_OVERRIDE = 'RELEASED_WITH_OVERRIDE',
  REVIEW_REQUESTED = 'REVIEW_REQUESTED',
  UNEVALUATED = 'UNEVALUATED',
}

export type ISubmapLink = {
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type ISubmapLinkInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type ISubscription = {
  funding_onPublishAsyncResponse?: Maybe<IAsyncResponse>;
  getFileAnalysis?: Maybe<ISampleFile>;
};

export type ISubscriptionFunding_OnPublishAsyncResponseArgs = {
  asyncRequestId: Scalars['ID']['input'];
  channelName: Scalars['String']['input'];
};

export type ISubscriptionGetFileAnalysisArgs = {
  filePath?: InputMaybe<Scalars['AWSURL']['input']>;
};

export enum ISupportsPaymentModalitiesEnum {
  DIRECTPAY = 'DirectPay',
  TUITIONASSISTANCE = 'TuitionAssistance',
  TUITIONREIMBURSEMENT = 'TuitionReimbursement',
}

export enum ITaxGrossupStatus {
  AVAILABLE = 'AVAILABLE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export type ITerm = {
  /** Academic Partner UUID */
  academicPartnerId: Scalars['ID']['output'];
  /** Term code */
  code: Scalars['String']['output'];
  /** Term dates object */
  dates: ITermDates;
  /** Unique identifier UUID */
  id: Scalars['ID']['output'];
  /** Flag that indicates whether or not this term is the active term within its owning learning partner */
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  /** Term name */
  name: Scalars['String']['output'];
  /** Parent Term (only populated for Session Terms) */
  parentTerm?: Maybe<ITerm>;
  /** List of Session Terms (only populated for Parent Terms) */
  sessions?: Maybe<Array<ITerm>>;
};

export type ITermCreateInput = {
  /** Academic Partner UUID */
  academicPartnerId: Scalars['ID']['input'];
  /** Term code */
  code: Scalars['String']['input'];
  /** If createdBy is not provided, it attempts to pull this from the jwt */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Term dates object */
  dates: ITermDatesInput;
  /** Set to true for test data (optional) */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Term name */
  name: Scalars['String']['input'];
  /** Term ID of Parent Term for creating a Session Term (optional) */
  parentTermId?: InputMaybe<Scalars['ID']['input']>;
  /** List of Session Terms to create with a Parent Term (optional) */
  sessions?: InputMaybe<Array<ISessionCreateInput>>;
};

export type ITermDates = {
  addDropDeadline?: Maybe<Scalars['String']['output']>;
  eligibilityFileTransferDate?: Maybe<Scalars['String']['output']>;
  eligibilityLockDate?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  enrollmentFileTransferDate?: Maybe<Scalars['String']['output']>;
  financialFileTransferDate?: Maybe<Scalars['String']['output']>;
  gradesFileTransferDate?: Maybe<Scalars['String']['output']>;
  reconFileTransferDate?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
};

export type ITermDatesInput = {
  /** Add/drop deadline */
  addDropDeadline?: InputMaybe<Scalars['String']['input']>;
  /** Eligibility file transfer date */
  eligibilityFileTransferDate?: InputMaybe<Scalars['String']['input']>;
  /** Eligibility lock date */
  eligibilityLockDate?: InputMaybe<Scalars['String']['input']>;
  /** End date */
  endDate: Scalars['String']['input'];
  /** Enrollment file transfer date */
  enrollmentFileTransferDate?: InputMaybe<Scalars['String']['input']>;
  /** Financial file transfer date */
  financialFileTransferDate?: InputMaybe<Scalars['String']['input']>;
  /** EGrades file transfer date */
  gradesFileTransferDate?: InputMaybe<Scalars['String']['input']>;
  /** Recon file transfer date */
  reconFileTransferDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date */
  startDate: Scalars['String']['input'];
};

export type ITermListResponse = {
  /** Max number of items per page */
  count: Scalars['Int']['output'];
  /** List of Terms */
  data: Array<ITerm>;
  /** Errors is a list of Errors including the error type and message and an AWS Request ID. */
  errors: Array<IErrorResponse>;
  /** Current page */
  page: Scalars['Int']['output'];
  /** Total count of all results */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type ITermsByCodesResponse = {
  errors?: Maybe<Array<IErrorResponse>>;
  terms: Array<ITerm>;
};

export type ITermsFilters = {
  /** Filter by Academic Partner UUID (Required) */
  academicPartnerId: Scalars['ID']['input'];
  /** Find terms that start have addDropDeadline's that start on or after the provided date. */
  addDropDeadlineDate?: InputMaybe<Scalars['String']['input']>;
  /** Allows the user to search the 'code' and 'name' fields with a single string input (SQL LIKE behaviour) */
  codeNameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Allows the user to search for terms that end on or before a given date. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Include test data (optional) */
  includeTests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters to include terms that have a startDate in the past and an end date on the current day or in the future */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters to include terms that have a startDate in the future */
  isFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters to include terms that have an endDate in the past */
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allows the user to search for terms that start on or after a given date. */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Allows the user to search for terms that start in the specified month in any year
   * Input is a typical date string, but the day of the month is ignored, only the month
   * and year is utilized.
   * Ex. 2023-01-12 and 2023-01-20 will both search for January 2023.
   */
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type ITermsOrderBySortInput = {
  /** Name of Term field */
  name: ITermSortField;
  /** Sort order (ASC or DESC) */
  sort?: InputMaybe<ITermSortOrder>;
};

export enum ITermSortField {
  /** Add/drop deadline */
  ADDDROPDEADLINE = 'addDropDeadline',
  /** Term code */
  CODE = 'code',
  /** Eligibility file transfer date */
  ELIGIBILITYFILETRANSFERDATE = 'eligibilityFileTransferDate',
  /** End date */
  ENDDATE = 'endDate',
  /** Enrollment file transfer date */
  ENROLLMENTFILETRANSFERDATE = 'enrollmentFileTransferDate',
  /** Financial file transfer date */
  FINANCIALFILETRANSFERDATE = 'financialFileTransferDate',
  /** Grades file transfer date */
  GRADESFILETRANSFERDATE = 'gradesFileTransferDate',
  /** Term ID */
  ID = 'id',
  /** Term name */
  NAME = 'name',
  /** Reconciliation file transfer date */
  RECONFILETRANSFERDATE = 'reconFileTransferDate',
  /** Start date */
  STARTDATE = 'startDate',
}

export enum ITermSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ITermUpdateInput = {
  /** Term dates object (optional) */
  dates?: InputMaybe<ITermDatesInput>;
  /** Term name (optional) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Term ID of Parent Term for linking a Session Term (optional) */
  parentTermId?: InputMaybe<Scalars['ID']['input']>;
};

export type ITermUpsertInput = {
  /** Term code */
  code: Scalars['String']['input'];
  /** If createdBy is not provided, it attempts to pull this from the jwt */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Term dates object */
  dates: ITermDatesInput;
  /** Term name */
  name: Scalars['String']['input'];
  /** List of Session Terms to create with a Parent Term (optional) */
  sessions?: InputMaybe<Array<ISessionCreateInput>>;
};

export type ITermUpsertInputWrapper = {
  /** Unique record identifier that will be returned in response (optional) */
  correlationId?: InputMaybe<Scalars['ID']['input']>;
  /** Term data */
  term: ITermUpsertInput;
};

export type IThemeTag = {
  title?: Maybe<Scalars['String']['output']>;
};

export type ITransactionRegistry_HelloWorld = {
  id: Scalars['String']['input'];
};

export type ITransactionRegistry_HelloWorldResponse = {
  input: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ITransferFrequencyEnum {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
}

export type ITuitionAssistance = IPaymentModalitySupport & {
  allowsDeferredTuition: Scalars['Boolean']['output'];
  effectiveDate: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  partnerType: ITuitionAssistancePartnerType;
  sponsoringEmployerIds?: Maybe<Array<Scalars['String']['output']>>;
  type: IPaymentModalityType;
};

export type ITuitionAssistanceInformationData = {
  appDueDate?: Maybe<Scalars['String']['output']>;
  programStartDate?: Maybe<Scalars['String']['output']>;
  tuitionAmount?: Maybe<Scalars['Int']['output']>;
};

export enum ITuitionAssistancePartnerType {
  EMPLOYERSPONSORED = 'EmployerSponsored',
  GUILDCERTIFIED = 'GuildCertified',
}

export enum ITuitionAssistancePartnerTypeEnum {
  EMPLOYERSPONSORED = 'EmployerSponsored',
  GUILDCERTIFIED = 'GuildCertified',
}

export type ITuitionAssistanceProductContext = {
  academicPartnerId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
};

export type ITuitionReimbursement = IPaymentModalitySupport & {
  allowsDeferredTuition: Scalars['Boolean']['output'];
  effectiveDate: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  type: IPaymentModalityType;
};

export type ITuitionReimbursementInformationData = {
  submissionEndDateDays?: Maybe<Scalars['Int']['output']>;
  submissionStartDateDays?: Maybe<Scalars['Int']['output']>;
  tuitionAmount?: Maybe<Scalars['Int']['output']>;
};

export type ITuitionReimbursementProductContext = {
  achievementType: Scalars['String']['input'];
  fieldOfStudyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for updating Academic Period */
export type IUpdateAcademicPeriodInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateBillingPeriodCohortStateExcludingReleaseRequest = {
  billingPeriodCohortId: Scalars['ID']['input'];
  state: IBillingPeriodCohortState;
};

/** Input type for updating Billing Period */
export type IUpdateBillingPeriodInput = {
  assessedTuitionFinalDate?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  eligibilityLockDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  epCreditMemoAppDate?: InputMaybe<Scalars['String']['input']>;
  epCreditMemoDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeeInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epServiceFeePaymentDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  epTuitionPaymentDate?: InputMaybe<Scalars['String']['input']>;
  financialFileDate?: InputMaybe<Scalars['String']['input']>;
  gradesFileDate?: InputMaybe<Scalars['String']['input']>;
  guildPaysTuitionDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prelimEligibilityDate?: InputMaybe<Scalars['String']['input']>;
  reconFileDate?: InputMaybe<Scalars['String']['input']>;
  reconInvoiceDate?: InputMaybe<Scalars['String']['input']>;
  reconPaymentDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateEnrollmentPeriodInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  commitmentDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  expectedEnrollmentFileDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateMemberUserNameInput = {
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
};

export type IUpsertEnrollmentPeriodsInput = {
  billingPeriodId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  commitmentDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type IUpsertEpPortalUserInput = {
  active: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  employerId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type IUpsertExchangeDateFormulasInput = {
  /** Exchange Date Type ID */
  exchangeDateTypeId: Scalars['ID']['input'];
  /** Offset formula text */
  offsetFormula: Scalars['String']['input'];
};

export type IUpsertMemberUserAuth0Input = {
  auth0Id: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type IUpsertRollcallBillingAndEnrollmentPeriodsInput = {
  assessedTuitionFinalDate: Scalars['String']['input'];
  code: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriods: Array<IUpsertEnrollmentPeriodsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type IUpsertRollcallDataExchangeDatesInput = {
  billingPeriodId: Scalars['ID']['input'];
  enrollmentPeriods: Array<IUpsertRollcallDataExchangeEnrollmentDatesInput>;
  epTuitionPayment?: InputMaybe<Scalars['String']['input']>;
  financialFile?: InputMaybe<Scalars['String']['input']>;
  gradeFile?: InputMaybe<Scalars['String']['input']>;
  reconFile?: InputMaybe<Scalars['String']['input']>;
  serviceFeeInvoice?: InputMaybe<Scalars['String']['input']>;
  serviceFeePayment?: InputMaybe<Scalars['String']['input']>;
  tuitionReconPayment?: InputMaybe<Scalars['String']['input']>;
};

export type IUpsertRollcallDataExchangeEnrollmentDatesInput = {
  enrollmentFile?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriodId: Scalars['ID']['input'];
};

export type IUpsertRollcallDataExchangeFormulasInput = {
  academicPartnerId: Scalars['ID']['input'];
  calendarId: Scalars['ID']['input'];
  commitmentDate?: InputMaybe<ICalendarFormula>;
  enrollmentFile?: InputMaybe<ICalendarFormula>;
  epTuitionPayment?: InputMaybe<ICalendarFormula>;
  financialFile?: InputMaybe<ICalendarFormula>;
  gradeFile?: InputMaybe<ICalendarFormula>;
  reconFile?: InputMaybe<ICalendarFormula>;
  serviceFeeInvoice?: InputMaybe<ICalendarFormula>;
  serviceFeePayment?: InputMaybe<ICalendarFormula>;
  skipFormulas: Scalars['Boolean']['input'];
  tuitionReconPayment?: InputMaybe<ICalendarFormula>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IUpsertRollcallDataExchangeFormulasResponse = {
  errors: Array<IErrorResponse>;
  success: Scalars['Boolean']['output'];
};

export type IUpsertTermsResponse = {
  /** Unique identifier that was provided in request */
  batchCorrelationId?: Maybe<Scalars['ID']['output']>;
  /** List of processing errors */
  errors?: Maybe<Array<IAcs_BatchProcessingErrorWrapper>>;
  /** List of term responses that were successfully processed */
  responseList?: Maybe<Array<IBatchProcessingTermResponse>>;
};

export type IUserOverridesInput = {
  employerUuid?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type IWritePathwaysForEmployerInput = {
  employerId: Scalars['ID']['input'];
  employerName: Scalars['String']['input'];
  pathwayEnabled: Scalars['Boolean']['input'];
  pathwayId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<InputMaybe<IPathwayCustomRoleInput>>>;
};

export type IMemberUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IMemberUserQuery = {
  memberUser?: {
    id: string;
    applications?: Array<{
      id: string;
      uuid: string;
      state?: string | null;
      programUuid?: string | null;
      academicPartnerUuid?: string | null;
      userId: string;
    }> | null;
    coachingLinks?: { growthCoachingLink?: string | null } | null;
  } | null;
};

export type IPathwaysQueryVariables = Exact<{
  employerId: Scalars['ID']['input'];
}>;

export type IPathwaysQuery = {
  pathways: Array<{
    pathwayId: string;
    content: { title?: string | null; shortDescription?: string | null };
  } | null>;
};

export type IGetPublicEmployerInfoQueryVariables = Exact<{
  employerId: Scalars['ID']['input'];
}>;

export type IGetPublicEmployerInfoQuery = {
  epol_getPublicEmployerInfo?: {
    employerResources?: Array<{ type?: string | null; value?: string | null } | null> | null;
  } | null;
};

export const MemberUserDocument = gql`
  query memberUser($id: ID!) {
    memberUser(id: $id) {
      id
      applications {
        id
        uuid
        state
        programUuid
        academicPartnerUuid
        userId
      }
      coachingLinks {
        growthCoachingLink
      }
    }
  }
`;

/**
 * __useMemberUserQuery__
 *
 * To run a query within a React component, call `useMemberUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemberUserQuery(
  baseOptions: Apollo.QueryHookOptions<IMemberUserQuery, IMemberUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IMemberUserQuery, IMemberUserQueryVariables>(MemberUserDocument, options);
}
export function useMemberUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IMemberUserQuery, IMemberUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IMemberUserQuery, IMemberUserQueryVariables>(
    MemberUserDocument,
    options
  );
}
export type MemberUserQueryHookResult = ReturnType<typeof useMemberUserQuery>;
export type MemberUserLazyQueryHookResult = ReturnType<typeof useMemberUserLazyQuery>;
export type MemberUserQueryResult = Apollo.QueryResult<IMemberUserQuery, IMemberUserQueryVariables>;
export const PathwaysDocument = gql`
  query pathways($employerId: ID!) {
    pathways(employerId: $employerId) {
      pathwayId
      content {
        title
        shortDescription
      }
    }
  }
`;

/**
 * __usePathwaysQuery__
 *
 * To run a query within a React component, call `usePathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwaysQuery({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function usePathwaysQuery(
  baseOptions: Apollo.QueryHookOptions<IPathwaysQuery, IPathwaysQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IPathwaysQuery, IPathwaysQueryVariables>(PathwaysDocument, options);
}
export function usePathwaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPathwaysQuery, IPathwaysQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IPathwaysQuery, IPathwaysQueryVariables>(PathwaysDocument, options);
}
export type PathwaysQueryHookResult = ReturnType<typeof usePathwaysQuery>;
export type PathwaysLazyQueryHookResult = ReturnType<typeof usePathwaysLazyQuery>;
export type PathwaysQueryResult = Apollo.QueryResult<IPathwaysQuery, IPathwaysQueryVariables>;
export const GetPublicEmployerInfoDocument = gql`
  query getPublicEmployerInfo($employerId: ID!) {
    epol_getPublicEmployerInfo(employerId: $employerId) {
      employerResources {
        type
        value
      }
    }
  }
`;

/**
 * __useGetPublicEmployerInfoQuery__
 *
 * To run a query within a React component, call `useGetPublicEmployerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicEmployerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicEmployerInfoQuery({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useGetPublicEmployerInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetPublicEmployerInfoQuery,
    IGetPublicEmployerInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IGetPublicEmployerInfoQuery, IGetPublicEmployerInfoQueryVariables>(
    GetPublicEmployerInfoDocument,
    options
  );
}
export function useGetPublicEmployerInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetPublicEmployerInfoQuery,
    IGetPublicEmployerInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IGetPublicEmployerInfoQuery, IGetPublicEmployerInfoQueryVariables>(
    GetPublicEmployerInfoDocument,
    options
  );
}
export type GetPublicEmployerInfoQueryHookResult = ReturnType<typeof useGetPublicEmployerInfoQuery>;
export type GetPublicEmployerInfoLazyQueryHookResult = ReturnType<
  typeof useGetPublicEmployerInfoLazyQuery
>;
export type GetPublicEmployerInfoQueryResult = Apollo.QueryResult<
  IGetPublicEmployerInfoQuery,
  IGetPublicEmployerInfoQueryVariables
>;
